var items = {
  "block.minecraft.acacia_button": "Akasia Knoppie",
  "block.minecraft.acacia_door": "Akasiahout Deur",
  "block.minecraft.acacia_fence": "Akasiahout Heining",
  "block.minecraft.acacia_fence_gate": "Akasiahout Hek",
  "block.minecraft.acacia_hanging_sign": "Akasia Hang Teken",
  "block.minecraft.acacia_leaves": "Akasiablare",
  "block.minecraft.acacia_log": "Akasiahout Stomp",
  "block.minecraft.acacia_planks": "Akasiahout Planke",
  "block.minecraft.acacia_pressure_plate": "Akasiahout Drukplaat",
  "block.minecraft.acacia_sapling": "Akasiaboom Stiggie",
  "block.minecraft.acacia_shelf": "Akasia Rak",
  "block.minecraft.acacia_sign": "Akasiahout teken",
  "block.minecraft.acacia_slab": "Akasiahout Blad",
  "block.minecraft.acacia_stairs": "Akasiahout Trappe",
  "block.minecraft.acacia_trapdoor": "Akasiahout Valdeur",
  "block.minecraft.acacia_wall_hanging_sign": "Akasia Muurhangende Teken",
  "block.minecraft.acacia_wall_sign": "Akasia Muur Teken",
  "block.minecraft.acacia_wood": "Akasiahout",
  "block.minecraft.activator_rail": "Skakelaarspoor",
  "block.minecraft.air": "Lug",
  "block.minecraft.allium": "Wilde Ui",
  "block.minecraft.amethyst_block": "Block van Ametis",
  "block.minecraft.amethyst_cluster": "Amethyst Kluster",
  "block.minecraft.ancient_debris": "Oer Puin",
  "block.minecraft.andesite": "Andesiet",
  "block.minecraft.andesite_slab": "Andesiet Blad",
  "block.minecraft.andesite_stairs": "Andesiet Trappe",
  "block.minecraft.andesite_wall": "Andesiet Muur",
  "block.minecraft.anvil": "Aambeeld",
  "block.minecraft.attached_melon_stem": "Aangehegte Waatlemoenstam",
  "block.minecraft.attached_pumpkin_stem": "Aangehegte Pampoensteel",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azalea Blare",
  "block.minecraft.azure_bluet": "Blou Aster",
  "block.minecraft.bamboo": "Bamboes",
  "block.minecraft.bamboo_block": "Blok van bamboes",
  "block.minecraft.bamboo_button": "Bamboes Knoppie",
  "block.minecraft.bamboo_door": "Bamboes deur",
  "block.minecraft.bamboo_fence": "Bamboesheining",
  "block.minecraft.bamboo_fence_gate": "Bamboesheininghek",
  "block.minecraft.bamboo_hanging_sign": "Bamboes hangende teken",
  "block.minecraft.bamboo_mosaic": "Bamboes mosaïek",
  "block.minecraft.bamboo_mosaic_slab": "Bamboes mosaïekplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboes Mosaïek Trappe",
  "block.minecraft.bamboo_planks": "Bamboes planke",
  "block.minecraft.bamboo_pressure_plate": "Bamboes drukplaat",
  "block.minecraft.bamboo_sapling": "Bamboes Spruit",
  "block.minecraft.bamboo_shelf": "Bamboes Rak",
  "block.minecraft.bamboo_sign": "Bamboes Teken",
  "block.minecraft.bamboo_slab": "Bamboesblad",
  "block.minecraft.bamboo_stairs": "Gebeitlde boekrak",
  "block.minecraft.bamboo_trapdoor": "Bamboes valdeur",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboes Muurhangende Teken",
  "block.minecraft.bamboo_wall_sign": "Bamboes Muur Teken",
  "block.minecraft.banner.base.black": "Heeltemal swart veld",
  "block.minecraft.banner.base.blue": "Ten volle blou veld",
  "block.minecraft.banner.base.brown": "Ten volle bruin veld",
  "block.minecraft.banner.base.cyan": "Volledig siaanveld",
  "block.minecraft.banner.base.gray": "Ten volle grys veld",
  "block.minecraft.banner.base.green": "Ten volle groen veld",
  "block.minecraft.banner.base.light_blue": "Volledig ligblou veld",
  "block.minecraft.banner.base.light_gray": "Ten volle liggrys veld",
  "block.minecraft.banner.base.lime": "Ten volle kalkveld",
  "block.minecraft.banner.base.magenta": "Ten volle Magenta veld",
  "block.minecraft.banner.base.orange": "Ten volle oranje veld",
  "block.minecraft.banner.base.pink": "Ten volle pienk veld",
  "block.minecraft.banner.base.purple": "Vol pers veld",
  "block.minecraft.banner.base.red": "Ten volle rooi veld",
  "block.minecraft.banner.base.white": "Ten volle wit veld",
  "block.minecraft.banner.base.yellow": "Ten volle geel veld",
  "block.minecraft.banner.border.black": "Swart Skild",
  "block.minecraft.banner.border.blue": "Blou Skildsoom",
  "block.minecraft.banner.border.brown": "Bruin Skildsoom",
  "block.minecraft.banner.border.cyan": "Blougroen Skildsoom",
  "block.minecraft.banner.border.gray": "Grys Skildsoom",
  "block.minecraft.banner.border.green": "Groen Skild",
  "block.minecraft.banner.border.light_blue": "Ligteblou Skildsoom",
  "block.minecraft.banner.border.light_gray": "Ligtegrys Skildsoom",
  "block.minecraft.banner.border.lime": "Lemmetjie Grens",
  "block.minecraft.banner.border.magenta": "Magenta Borduur",
  "block.minecraft.banner.border.orange": "Oranje Borduur",
  "block.minecraft.banner.border.pink": "Pienk Skildsoom",
  "block.minecraft.banner.border.purple": "Pers Skildsoom",
  "block.minecraft.banner.border.red": "Rooi Skild",
  "block.minecraft.banner.border.white": "Wit Borduur",
  "block.minecraft.banner.border.yellow": "Geel Skildsoom",
  "block.minecraft.banner.bricks.black": "Swart Veld Masoned",
  "block.minecraft.banner.bricks.blue": "Blou Veld Masoned",
  "block.minecraft.banner.bricks.brown": "Bruin Veld Masoned",
  "block.minecraft.banner.bricks.cyan": "Blougroen Baksteenpatroon",
  "block.minecraft.banner.bricks.gray": "Grys Veld Masoned",
  "block.minecraft.banner.bricks.green": "Groen Veld Masoned",
  "block.minecraft.banner.bricks.light_blue": "Ligte Blou Veld Masoned",
  "block.minecraft.banner.bricks.light_gray": "Ligte Grys Veld Masoned",
  "block.minecraft.banner.bricks.lime": "Lemmetjie Steenwerk",
  "block.minecraft.banner.bricks.magenta": "Magenta Veld Masoned",
  "block.minecraft.banner.bricks.orange": "Oranje Veld Masoned",
  "block.minecraft.banner.bricks.pink": "Pienk Veld Masoned",
  "block.minecraft.banner.bricks.purple": "Pers Veld Masoned",
  "block.minecraft.banner.bricks.red": "Rooi Veld Masoned",
  "block.minecraft.banner.bricks.white": "Wit Veld Masoned",
  "block.minecraft.banner.bricks.yellow": "Geel Veld Masoned",
  "block.minecraft.banner.circle.black": "Swart Rondeel",
  "block.minecraft.banner.circle.blue": "Blou Rondeel",
  "block.minecraft.banner.circle.brown": "Bruin Rondeel",
  "block.minecraft.banner.circle.cyan": "Siaan Rondeel",
  "block.minecraft.banner.circle.gray": "Grys Rondeel",
  "block.minecraft.banner.circle.green": "Groen Rondeel",
  "block.minecraft.banner.circle.light_blue": "Ligte Blou Rondeel",
  "block.minecraft.banner.circle.light_gray": "Ligte Grys Rondeel",
  "block.minecraft.banner.circle.lime": "Lemmetjie Bolpunt",
  "block.minecraft.banner.circle.magenta": "Magenta Rondeel",
  "block.minecraft.banner.circle.orange": "Oranje Rondeel",
  "block.minecraft.banner.circle.pink": "Pienk Rondeel",
  "block.minecraft.banner.circle.purple": "Pers Rondeel",
  "block.minecraft.banner.circle.red": "Rooi Rondeel",
  "block.minecraft.banner.circle.white": "Wit Rondeel",
  "block.minecraft.banner.circle.yellow": "Geel Rondeel",
  "block.minecraft.banner.creeper.black": "Swart Creeper Wapenprent",
  "block.minecraft.banner.creeper.blue": "Blou Creeper Wapenprent",
  "block.minecraft.banner.creeper.brown": "Bruin Creeper Wapenprent",
  "block.minecraft.banner.creeper.cyan": "Blougroen Creeper Wapenprent",
  "block.minecraft.banner.creeper.gray": "Grys Creeper Wapenprent",
  "block.minecraft.banner.creeper.green": "Groen Creeper Wapenprent",
  "block.minecraft.banner.creeper.light_blue": "Ligblou Creeper Wapenprent",
  "block.minecraft.banner.creeper.light_gray": "Liggrys Creeper Wapenprent",
  "block.minecraft.banner.creeper.lime": "Lemmetjie Creeper Wapenprent",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper Wapenprent",
  "block.minecraft.banner.creeper.orange": "Oranje Creeper Wapenprent",
  "block.minecraft.banner.creeper.pink": "Pienk Creeper Wapenprent",
  "block.minecraft.banner.creeper.purple": "Pers Creeper Wapenprent",
  "block.minecraft.banner.creeper.red": "Rooi Creeper Wapenprent",
  "block.minecraft.banner.creeper.white": "Wit Creeper Wapenprent",
  "block.minecraft.banner.creeper.yellow": "Geel Creeper Wapenprent",
  "block.minecraft.banner.cross.black": "Swart Skuinskruis",
  "block.minecraft.banner.cross.blue": "Blou Skuinskruis",
  "block.minecraft.banner.cross.brown": "Bruin Skuinskruis",
  "block.minecraft.banner.cross.cyan": "Siaan Skuinskruis",
  "block.minecraft.banner.cross.gray": "Grys Skuinskruis",
  "block.minecraft.banner.cross.green": "Groen Skuinskruis",
  "block.minecraft.banner.cross.light_blue": "Ligte Blou Skuinskruis",
  "block.minecraft.banner.cross.light_gray": "Ligte Grys Skuinskruis",
  "block.minecraft.banner.cross.lime": "Lemmetjie Groen Skuinskruis",
  "block.minecraft.banner.cross.magenta": "Magenta Skuinskruis",
  "block.minecraft.banner.cross.orange": "Oranje Skuinskruis",
  "block.minecraft.banner.cross.pink": "Pienk Skuinskruis",
  "block.minecraft.banner.cross.purple": "Pers Skuinskruis",
  "block.minecraft.banner.cross.red": "Rooi Skuinskruis",
  "block.minecraft.banner.cross.white": "Wit Skuinskruis",
  "block.minecraft.banner.cross.yellow": "Geel Skuinskruis",
  "block.minecraft.banner.curly_border.black": "Swart Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.blue": "Blou Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.brown": "Bruin Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.cyan": "Blougroen Ingekeepte Skildsoom",
  "block.minecraft.banner.curly_border.gray": "Grys Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.green": "Groen Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.light_blue": "Lig Blou Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.light_gray": "Lig Grys Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.lime": "Heldergroen Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.magenta": "Magenta Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.orange": "Oranje Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.pink": "Pienk Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.purple": "Pers Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.red": "Rooi Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.white": "Wit Ingekeepde Borduur",
  "block.minecraft.banner.curly_border.yellow": "Geel Ingekeepde Borduur",
  "block.minecraft.banner.diagonal_left.black": "Swart Per draai Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blou Per draai Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Bruin Per draai Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Siaan Per draai Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Grys Per draai Sinister",
  "block.minecraft.banner.diagonal_left.green": "Groen Per draai Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Lig blou Per draai Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Ligte grys Per draai Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Lemmetjie Barensteel",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Per draai Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Oranje Per draai Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Pienk Per draai Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Pers Per draai Sinister",
  "block.minecraft.banner.diagonal_left.red": "Rooi Per draai Sinister",
  "block.minecraft.banner.diagonal_left.white": "Wit Per draai Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Geel Per draai Sinister",
  "block.minecraft.banner.diagonal_right.black": "Swart Per draai",
  "block.minecraft.banner.diagonal_right.blue": "Blou Per draai",
  "block.minecraft.banner.diagonal_right.brown": "Bruin Per draai",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan Per draai",
  "block.minecraft.banner.diagonal_right.gray": "Grys Per draai",
  "block.minecraft.banner.diagonal_right.green": "Groen Per draai",
  "block.minecraft.banner.diagonal_right.light_blue": "Lig blou Per draai",
  "block.minecraft.banner.diagonal_right.light_gray": "Ligte grys Per draai",
  "block.minecraft.banner.diagonal_right.lime": "Lemmetjie Baander",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Per draai",
  "block.minecraft.banner.diagonal_right.orange": "Oranje Per draai",
  "block.minecraft.banner.diagonal_right.pink": "Pienk Per draai",
  "block.minecraft.banner.diagonal_right.purple": "Pers Per draai",
  "block.minecraft.banner.diagonal_right.red": "Rooi Per draai",
  "block.minecraft.banner.diagonal_right.white": "Wit Per draai",
  "block.minecraft.banner.diagonal_right.yellow": "Geel Per draai",
  "block.minecraft.banner.diagonal_up_left.black": "Swart Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.blue": "Blou Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.brown": "Bruin Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.gray": "Grys Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.green": "Groen Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lig blou Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ligte grys Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.lime": "Omgekeerde Lemmetjie Baander",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranje Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.pink": "Pienk Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.purple": "Pers Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.red": "Rooi Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.white": "Wit Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_left.yellow": "Geel Per draai omgekeerde",
  "block.minecraft.banner.diagonal_up_right.black": "Swart Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.blue": "Blou Per draai onheilspellend omgekeerde",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruin Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.gray": "Grys Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.green": "Groen Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lig blou Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ligte grys Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.lime": "Omgekeerde Lemmetjie Barensteel",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranje Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.pink": "Pienk Per draai onheilspellend omgekeerde",
  "block.minecraft.banner.diagonal_up_right.purple": "Pers Per draai onheilspellend omgekeerde",
  "block.minecraft.banner.diagonal_up_right.red": "Rooi Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.white": "Wit Per draai Sinister omgekeerde",
  "block.minecraft.banner.diagonal_up_right.yellow": "Geel Per draai Sinister omgekeerde",
  "block.minecraft.banner.flow.black": "Swartvloei",
  "block.minecraft.banner.flow.blue": "Blouvloei",
  "block.minecraft.banner.flow.brown": "Bruinvloei",
  "block.minecraft.banner.flow.cyan": "Sianvloei",
  "block.minecraft.banner.flow.gray": "Grys vloei",
  "block.minecraft.banner.flow.green": "Groenvloei",
  "block.minecraft.banner.flow.light_blue": "Ligblouvloei",
  "block.minecraft.banner.flow.light_gray": "Lig grys vloei",
  "block.minecraft.banner.flow.lime": "Lemoenvloei",
  "block.minecraft.banner.flow.magenta": "Magentavloei",
  "block.minecraft.banner.flow.orange": "Oranjevloei",
  "block.minecraft.banner.flow.pink": "Pienkvloei",
  "block.minecraft.banner.flow.purple": "Persvloei",
  "block.minecraft.banner.flow.red": "Rooi Vloei",
  "block.minecraft.banner.flow.white": "Witte Vloei",
  "block.minecraft.banner.flow.yellow": "Geel Vloei",
  "block.minecraft.banner.flower.black": "Swart Blom Wapenprent",
  "block.minecraft.banner.flower.blue": "Blou Blom Wapenprent",
  "block.minecraft.banner.flower.brown": "Bruin Blom Wapenprent",
  "block.minecraft.banner.flower.cyan": "Blougroen Blom Wapenprent",
  "block.minecraft.banner.flower.gray": "Grys Blom Wapenprent",
  "block.minecraft.banner.flower.green": "Groen Blom Wapenprent",
  "block.minecraft.banner.flower.light_blue": "Ligblou Blom Wapenprent",
  "block.minecraft.banner.flower.light_gray": "Liggrys Blom Wapenprent",
  "block.minecraft.banner.flower.lime": "Lemmetjie Wapenprent",
  "block.minecraft.banner.flower.magenta": "Magenta Wapenprent",
  "block.minecraft.banner.flower.orange": "Oranje Blom Wapenprent",
  "block.minecraft.banner.flower.pink": "Pienk Blom Wapenprent",
  "block.minecraft.banner.flower.purple": "Pers Blom Wapenprent",
  "block.minecraft.banner.flower.red": "Rooi Blom Wapenprent",
  "block.minecraft.banner.flower.white": "Wit Blom Wapenprent",
  "block.minecraft.banner.flower.yellow": "Geel Blom Wapenprent",
  "block.minecraft.banner.globe.black": "Swart Wêreldbol",
  "block.minecraft.banner.globe.blue": "Blou Wêreldbol",
  "block.minecraft.banner.globe.brown": "Bruin Wêreldbol",
  "block.minecraft.banner.globe.cyan": "Blougroen Aardbol",
  "block.minecraft.banner.globe.gray": "Grys Wêreldbol",
  "block.minecraft.banner.globe.green": "Groen Wêreldbol",
  "block.minecraft.banner.globe.light_blue": "Ligte Blou Globe",
  "block.minecraft.banner.globe.light_gray": "Liggrys aardbol",
  "block.minecraft.banner.globe.lime": "Lemmetjie Aardbol",
  "block.minecraft.banner.globe.magenta": "Pers aardbol",
  "block.minecraft.banner.globe.orange": "Oranje aardbol",
  "block.minecraft.banner.globe.pink": "Pienk aardbol",
  "block.minecraft.banner.globe.purple": "Pers Wêreldbol",
  "block.minecraft.banner.globe.red": "Rooi aardbol",
  "block.minecraft.banner.globe.white": "Wit aardbol",
  "block.minecraft.banner.globe.yellow": "Geel aardbol",
  "block.minecraft.banner.gradient.black": "Swart gradiënt",
  "block.minecraft.banner.gradient.blue": "Blou gradiënt",
  "block.minecraft.banner.gradient.brown": "Bruin gradiënt",
  "block.minecraft.banner.gradient.cyan": "Blougroengradiënt",
  "block.minecraft.banner.gradient.gray": "Grys ​​gradiënt",
  "block.minecraft.banner.gradient.green": "Groen gradiënt",
  "block.minecraft.banner.gradient.light_blue": "Ligblou gradiënt",
  "block.minecraft.banner.gradient.light_gray": "Liggrys gradiënt",
  "block.minecraft.banner.gradient.lime": "Lemmetjie Gradiënt",
  "block.minecraft.banner.gradient.magenta": "Pers gradiënt",
  "block.minecraft.banner.gradient.orange": "Oranje gradiënt",
  "block.minecraft.banner.gradient.pink": "Pienk gradiënt",
  "block.minecraft.banner.gradient.purple": "Pers gradiënt",
  "block.minecraft.banner.gradient.red": "Rooi gradiënt",
  "block.minecraft.banner.gradient.white": "Wit gradiënt",
  "block.minecraft.banner.gradient.yellow": "Geel gradiënt",
  "block.minecraft.banner.gradient_up.black": "Swart basisgradiënt",
  "block.minecraft.banner.gradient_up.blue": "Blou Basis Helling",
  "block.minecraft.banner.gradient_up.brown": "Bruin basisgradiënt",
  "block.minecraft.banner.gradient_up.cyan": "Blougroen Basis Gradiënt",
  "block.minecraft.banner.gradient_up.gray": "Grys ​​basisgradiënt",
  "block.minecraft.banner.gradient_up.green": "Groen basisgradiënt",
  "block.minecraft.banner.gradient_up.light_blue": "Blou basisgradiënt",
  "block.minecraft.banner.gradient_up.light_gray": "Liggrys basisgradiënt",
  "block.minecraft.banner.gradient_up.lime": "Lemmetjie Basis Gradiënt",
  "block.minecraft.banner.gradient_up.magenta": "Pers basisgradiënt",
  "block.minecraft.banner.gradient_up.orange": "Oranje basisgradiënt",
  "block.minecraft.banner.gradient_up.pink": "Pienk basisgradiënt",
  "block.minecraft.banner.gradient_up.purple": "Pers basisgradiënt",
  "block.minecraft.banner.gradient_up.red": "Rooi basisgradiënt",
  "block.minecraft.banner.gradient_up.white": "Wit basisgradiënt",
  "block.minecraft.banner.gradient_up.yellow": "Geel basisgradiënt",
  "block.minecraft.banner.guster.black": "Swart Gaster",
  "block.minecraft.banner.guster.blue": "Blou Gaster",
  "block.minecraft.banner.guster.brown": "Bruin gaster",
  "block.minecraft.banner.guster.cyan": "Blou Gaster",
  "block.minecraft.banner.guster.gray": "Grys ​​brasem",
  "block.minecraft.banner.guster.green": "Groen brasem",
  "block.minecraft.banner.guster.light_blue": "Ligblou silwer brasem",
  "block.minecraft.banner.guster.light_gray": "Liggrys gaster",
  "block.minecraft.banner.guster.lime": "Lemmetjiegaster",
  "block.minecraft.banner.guster.magenta": "Pers gaster",
  "block.minecraft.banner.guster.orange": "Lemoen gaster",
  "block.minecraft.banner.guster.pink": "Pienk gaster",
  "block.minecraft.banner.guster.purple": "Pers gaster",
  "block.minecraft.banner.guster.red": "Rooi Guster",
  "block.minecraft.banner.guster.white": "Wit Guster",
  "block.minecraft.banner.guster.yellow": "Geel Guster",
  "block.minecraft.banner.half_horizontal.black": "Swart Deursnit",
  "block.minecraft.banner.half_horizontal.blue": "Blou Deursnit",
  "block.minecraft.banner.half_horizontal.brown": "Bruin Deursnit",
  "block.minecraft.banner.half_horizontal.cyan": "Blougroen Deursnit",
  "block.minecraft.banner.half_horizontal.gray": "Grys Deursnit",
  "block.minecraft.banner.half_horizontal.green": "Groen Deursnit",
  "block.minecraft.banner.half_horizontal.light_blue": "Ligblou Deursnit",
  "block.minecraft.banner.half_horizontal.light_gray": "Liggrys Deursnit",
  "block.minecraft.banner.half_horizontal.lime": "Lemmetjie Deursnit",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Deursnit",
  "block.minecraft.banner.half_horizontal.orange": "Oranje Deursnit",
  "block.minecraft.banner.half_horizontal.pink": "Pienk Deursnit",
  "block.minecraft.banner.half_horizontal.purple": "Pers Deursnit",
  "block.minecraft.banner.half_horizontal.red": "Rooi Deursnit",
  "block.minecraft.banner.half_horizontal.white": "Wit Deursnit",
  "block.minecraft.banner.half_horizontal.yellow": "Geel Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.black": "Omgekeerde Swart Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Omgekeerde Blou Dwarssnit",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Omgekeerde Bruin Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Omgekeerde Blougroen Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Omgekeerde Grys Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.green": "Omgekeerde Groen Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Omgekeerde Ligblou Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Omgekeerde Liggrys Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Omgekeerde Lemmetjie Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Omgekeerde Magenta Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Omgekeerde Oranje Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Omgekeerde Pienk Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Omgekeerde Pers Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.red": "Omgekeerde Rooi Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.white": "Omgekeerde Wit Deursnit",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Omgekeerde Blou Deursnit",
  "block.minecraft.banner.half_vertical.black": "Swart Tot Bleek",
  "block.minecraft.banner.half_vertical.blue": "Blou Tot Bleek",
  "block.minecraft.banner.half_vertical.brown": "Bruin Tot Bleek",
  "block.minecraft.banner.half_vertical.cyan": "Blou Tot Bleek",
  "block.minecraft.banner.half_vertical.gray": "Grys Tot Bleek",
  "block.minecraft.banner.half_vertical.green": "Groen Tot Bleek",
  "block.minecraft.banner.half_vertical.light_blue": "Ligblou Tot Bleek",
  "block.minecraft.banner.half_vertical.light_gray": "Liggrys Tot Bleek",
  "block.minecraft.banner.half_vertical.lime": "Lemmetjie Per Pale",
  "block.minecraft.banner.half_vertical.magenta": "Pers Tot Bleek",
  "block.minecraft.banner.half_vertical.orange": "Oranje Tot Bleek",
  "block.minecraft.banner.half_vertical.pink": "Rooi Tot Bleek",
  "block.minecraft.banner.half_vertical.purple": "Pers Tot Bleek",
  "block.minecraft.banner.half_vertical.red": "Rooi Tot Bleek",
  "block.minecraft.banner.half_vertical.white": "Wit Tot Bleek",
  "block.minecraft.banner.half_vertical.yellow": "Geel Tot Bleek",
  "block.minecraft.banner.half_vertical_right.black": "Swart Op Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.blue": "Blou Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.brown": "Bruin Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.cyan": "Blou Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.gray": "Grys Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.green": "Groen Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ligblou Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_gray": "Liggrys Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.lime": "Omgekeerde Lemmetjie Per Pale",
  "block.minecraft.banner.half_vertical_right.magenta": "Pers Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.orange": "Oranje Op'n Bleek Omgekeerde",
  "block.minecraft.banner.half_vertical_right.pink": "Rooi Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.purple": "Pers Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.red": "Rooi Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.white": "Wit Tot Bleek Omgekeerd",
  "block.minecraft.banner.half_vertical_right.yellow": "Geel Tot Bleek Omgekeerd",
  "block.minecraft.banner.mojang.black": "Swart Ding",
  "block.minecraft.banner.mojang.blue": "Blou Ding",
  "block.minecraft.banner.mojang.brown": "Bruin Ding",
  "block.minecraft.banner.mojang.cyan": "Blougroen Ding",
  "block.minecraft.banner.mojang.gray": "Grys Ding",
  "block.minecraft.banner.mojang.green": "Groen Ding",
  "block.minecraft.banner.mojang.light_blue": "Ligblou Ding",
  "block.minecraft.banner.mojang.light_gray": "Liggrys Ding",
  "block.minecraft.banner.mojang.lime": "Lemmetjiegroen Ding",
  "block.minecraft.banner.mojang.magenta": "Magenta Ding",
  "block.minecraft.banner.mojang.orange": "Oranje Ding",
  "block.minecraft.banner.mojang.pink": "Pienk Ding",
  "block.minecraft.banner.mojang.purple": "Pers Ding",
  "block.minecraft.banner.mojang.red": "Rooi Ring",
  "block.minecraft.banner.mojang.white": "Wit Ding",
  "block.minecraft.banner.mojang.yellow": "Geel Ding",
  "block.minecraft.banner.piglin.black": "Swart Snoet",
  "block.minecraft.banner.piglin.blue": "Blou Snoet",
  "block.minecraft.banner.piglin.brown": "Bruin Snoet",
  "block.minecraft.banner.piglin.cyan": "Blougroen Snoet",
  "block.minecraft.banner.piglin.gray": "Grys Snoet",
  "block.minecraft.banner.piglin.green": "Groen Snoet",
  "block.minecraft.banner.piglin.light_blue": "Ligteblou Snoet",
  "block.minecraft.banner.piglin.light_gray": "Liggrys Snoet",
  "block.minecraft.banner.piglin.lime": "Lemmetjie Snoet",
  "block.minecraft.banner.piglin.magenta": "Magenta Snoet",
  "block.minecraft.banner.piglin.orange": "Oranje Snoet",
  "block.minecraft.banner.piglin.pink": "Pienk Snoet",
  "block.minecraft.banner.piglin.purple": "Pers Snoet",
  "block.minecraft.banner.piglin.red": "Rooi Snoet",
  "block.minecraft.banner.piglin.white": "Wit Snoet",
  "block.minecraft.banner.piglin.yellow": "Geel Snoet",
  "block.minecraft.banner.rhombus.black": "Swart Keeltablet",
  "block.minecraft.banner.rhombus.blue": "Blou Keeltablet",
  "block.minecraft.banner.rhombus.brown": "Bruin Keeltablet",
  "block.minecraft.banner.rhombus.cyan": "Siaan Keeltablet",
  "block.minecraft.banner.rhombus.gray": "Grys Keeltablet",
  "block.minecraft.banner.rhombus.green": "Groen Keeltablet",
  "block.minecraft.banner.rhombus.light_blue": "Ligte Blou Keeltablet",
  "block.minecraft.banner.rhombus.light_gray": "Ligte Grys Keeltablet",
  "block.minecraft.banner.rhombus.lime": "Lemmetjie Ruit",
  "block.minecraft.banner.rhombus.magenta": "Magenta Keeltablet",
  "block.minecraft.banner.rhombus.orange": "Oranje Keeltablet",
  "block.minecraft.banner.rhombus.pink": "Pienk Keeltablet",
  "block.minecraft.banner.rhombus.purple": "Pers Keeltablet",
  "block.minecraft.banner.rhombus.red": "Rooi Pastille",
  "block.minecraft.banner.rhombus.white": "Wit diamant",
  "block.minecraft.banner.rhombus.yellow": "Geel diamant",
  "block.minecraft.banner.skull.black": "Swart Skedel Wapenprent",
  "block.minecraft.banner.skull.blue": "Blou Skedel Wapenprent",
  "block.minecraft.banner.skull.brown": "Bruin Skedel Wapenprent",
  "block.minecraft.banner.skull.cyan": "Blougroen Skedel Wapenprent",
  "block.minecraft.banner.skull.gray": "Grys Skedel Wapenprent",
  "block.minecraft.banner.skull.green": "Groen Skedel Wapenprent",
  "block.minecraft.banner.skull.light_blue": "Ligblou Skedel Wapenprent",
  "block.minecraft.banner.skull.light_gray": "Liggrys Skedel Wapenprent",
  "block.minecraft.banner.skull.lime": "Kalk Skedel Wapenprent",
  "block.minecraft.banner.skull.magenta": "Magenta Skedel Wapenprent",
  "block.minecraft.banner.skull.orange": "Oranje Skedel Wapenprent",
  "block.minecraft.banner.skull.pink": "Pienk Skedel Wapenprent",
  "block.minecraft.banner.skull.purple": "Pers Skedel Wapenprent",
  "block.minecraft.banner.skull.red": "Rooi Skedel Wapenprent",
  "block.minecraft.banner.skull.white": "Wit Skedel Wapenprent",
  "block.minecraft.banner.skull.yellow": "Geel Skedel Wapenprent",
  "block.minecraft.banner.small_stripes.black": "Swart Paly",
  "block.minecraft.banner.small_stripes.blue": "Blou Palium",
  "block.minecraft.banner.small_stripes.brown": "Bruin Paal",
  "block.minecraft.banner.small_stripes.cyan": "Blou Bleek",
  "block.minecraft.banner.small_stripes.gray": "Grys Bleek",
  "block.minecraft.banner.small_stripes.green": "Groen Palium",
  "block.minecraft.banner.small_stripes.light_blue": "Ligblou Fawn",
  "block.minecraft.banner.small_stripes.light_gray": "Liggrys Bleek",
  "block.minecraft.banner.small_stripes.lime": "Kalkpalium",
  "block.minecraft.banner.small_stripes.magenta": "Pers bleek",
  "block.minecraft.banner.small_stripes.orange": "Oranje Palium",
  "block.minecraft.banner.small_stripes.pink": "Pienk Bleek",
  "block.minecraft.banner.small_stripes.purple": "Pers Bleek",
  "block.minecraft.banner.small_stripes.red": "Rooi Paly",
  "block.minecraft.banner.small_stripes.white": "Wit Bleek",
  "block.minecraft.banner.small_stripes.yellow": "Geel Bleek",
  "block.minecraft.banner.square_bottom_left.black": "Dexter Canton Swartbasis",
  "block.minecraft.banner.square_bottom_left.blue": "Dexter Canton Blou Basis",
  "block.minecraft.banner.square_bottom_left.brown": "Brown Dexter Canton-Basis",
  "block.minecraft.banner.square_bottom_left.cyan": "Blou Base Dexter Kanton",
  "block.minecraft.banner.square_bottom_left.gray": "Gris Basiese Dexter Kanton",
  "block.minecraft.banner.square_bottom_left.green": "Dexter Canton Groenbasis",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ligblou Dexter Canton-basis",
  "block.minecraft.banner.square_bottom_left.light_gray": "Liggrys Dexter Canton basis",
  "block.minecraft.banner.square_bottom_left.lime": "Dexter Canton Kalkbasis",
  "block.minecraft.banner.square_bottom_left.magenta": "Die Purple Dexter Canton-Basis",
  "block.minecraft.banner.square_bottom_left.orange": "Dexter Canton Oranje Basis",
  "block.minecraft.banner.square_bottom_left.pink": "Pink Dexter Canton-Basis",
  "block.minecraft.banner.square_bottom_left.purple": "Die Purple Dexter Canton-Basis",
  "block.minecraft.banner.square_bottom_left.red": "Rooi Dexter Kantonbasis",
  "block.minecraft.banner.square_bottom_left.white": "Dexter Canton Witbasis",
  "block.minecraft.banner.square_bottom_left.yellow": "Dexter Canton Geel Basis",
  "block.minecraft.banner.square_bottom_right.black": "Die Swart Basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.blue": "Die Blou basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.brown": "Die Bruin basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.cyan": "Die Blou Basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.gray": "Die Grys Basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.green": "Die Groen Basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Die ligblou basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Die liggrys basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.lime": "Die kalkbasis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпурная основа Зловещего кантона",
  "block.minecraft.banner.square_bottom_right.orange": "Die Oranje basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.pink": "Die pienk basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.purple": "Die Pers Basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.red": "Die Rooi Basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.white": "Die Wit basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_bottom_right.yellow": "Die Geel basis Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_left.black": "Die Swart Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.blue": "Blou Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.brown": "Brown Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.cyan": "Blou Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.gray": "Grys Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.green": "Die Groen Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.light_blue": "Ligblou Sjef Dexter Canton",
  "block.minecraft.banner.square_top_left.light_gray": "Liggrys Sjef Dexter Canton",
  "block.minecraft.banner.square_top_left.lime": "Stel Polisiehoof Dexter Canton In Kennis",
  "block.minecraft.banner.square_top_left.magenta": "Die Pers Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.orange": "Die leier Van Die Oranje Dexter-Kanton",
  "block.minecraft.banner.square_top_left.pink": "Rooi Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.purple": "Die Pers Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.red": "Rooi Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.white": "Wit Hoof Dexter Canton",
  "block.minecraft.banner.square_top_left.yellow": "Jill Hof Dexter Canton",
  "block.minecraft.banner.square_top_right.black": "Die Swart Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.blue": "Die Blou Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.brown": "Die Bruin Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.cyan": "Die Blou Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.gray": "Die Grys Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.green": "Die Groen Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.light_blue": "Die Ligblou Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.light_gray": "Die Liggrys Hoof Van Die Sinistere Kanton",
  "block.minecraft.banner.square_top_right.lime": "Stel die leier van Die Sinistere Kanton in kennis",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Hoof Sinistere Kanton",
  "block.minecraft.banner.square_top_right.orange": "Oranje Hoof Sinistere Kanton",
  "block.minecraft.banner.square_top_right.pink": "Pienk Hoof Sinistere Kanton",
  "block.minecraft.banner.square_top_right.purple": "Pers Hoof Sinistere Kanton",
  "block.minecraft.banner.square_top_right.red": "Rooi Hoof Sinistere Kanton",
  "block.minecraft.banner.square_top_right.white": "Wit Hoof Sinistere Kanton",
  "block.minecraft.banner.square_top_right.yellow": "Geel Hoof Sinistere Kanton",
  "block.minecraft.banner.straight_cross.black": "Die Swart Kruis",
  "block.minecraft.banner.straight_cross.blue": "Blou Kruis",
  "block.minecraft.banner.straight_cross.brown": "Die Bruin Kruis",
  "block.minecraft.banner.straight_cross.cyan": "Blougroen Kruis",
  "block.minecraft.banner.straight_cross.gray": "Grys Kruis",
  "block.minecraft.banner.straight_cross.green": "Die Groen Kruis",
  "block.minecraft.banner.straight_cross.light_blue": "Ligblou Kruis",
  "block.minecraft.banner.straight_cross.light_gray": "Liggrys kruis",
  "block.minecraft.banner.straight_cross.lime": "Lemmetjie Kruis",
  "block.minecraft.banner.straight_cross.magenta": "Die Pers Kruis",
  "block.minecraft.banner.straight_cross.orange": "Oranje Kruis",
  "block.minecraft.banner.straight_cross.pink": "Rooi Kruis",
  "block.minecraft.banner.straight_cross.purple": "Die Pers Kruis",
  "block.minecraft.banner.straight_cross.red": "Die Rooi Kruis",
  "block.minecraft.banner.straight_cross.white": "Die Wit Kruis",
  "block.minecraft.banner.straight_cross.yellow": "Geel Kruis",
  "block.minecraft.banner.stripe_bottom.black": "Swart basis",
  "block.minecraft.banner.stripe_bottom.blue": "Blou basis",
  "block.minecraft.banner.stripe_bottom.brown": "Bruin basis",
  "block.minecraft.banner.stripe_bottom.cyan": "Blou basis",
  "block.minecraft.banner.stripe_bottom.gray": "Grys basis",
  "block.minecraft.banner.stripe_bottom.green": "Groen basis",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ligblou basis",
  "block.minecraft.banner.stripe_bottom.light_gray": "Liggrys basis",
  "block.minecraft.banner.stripe_bottom.lime": "Kalkbasis",
  "block.minecraft.banner.stripe_bottom.magenta": "Pers basis",
  "block.minecraft.banner.stripe_bottom.orange": "Oranje basis",
  "block.minecraft.banner.stripe_bottom.pink": "Rooi basis",
  "block.minecraft.banner.stripe_bottom.purple": "Pers basis",
  "block.minecraft.banner.stripe_bottom.red": "Rooi basis",
  "block.minecraft.banner.stripe_bottom.white": "Wit basis",
  "block.minecraft.banner.stripe_bottom.yellow": "Geel basis",
  "block.minecraft.banner.stripe_center.black": "Swart Bleek",
  "block.minecraft.banner.stripe_center.blue": "Blou Paal",
  "block.minecraft.banner.stripe_center.brown": "Bruin Paal",
  "block.minecraft.banner.stripe_center.cyan": "Siaan Paal",
  "block.minecraft.banner.stripe_center.gray": "Grys Paal",
  "block.minecraft.banner.stripe_center.green": "Groen Paal",
  "block.minecraft.banner.stripe_center.light_blue": "Ligte Blou Paal",
  "block.minecraft.banner.stripe_center.light_gray": "Ligte Grys Paal",
  "block.minecraft.banner.stripe_center.lime": "Lemmetjie Groen Paal",
  "block.minecraft.banner.stripe_center.magenta": "Magenta Paal",
  "block.minecraft.banner.stripe_center.orange": "Oranje Paal",
  "block.minecraft.banner.stripe_center.pink": "Pienk Paal",
  "block.minecraft.banner.stripe_center.purple": "Pers Paal",
  "block.minecraft.banner.stripe_center.red": "Rooi Paal",
  "block.minecraft.banner.stripe_center.white": "Wit Paal",
  "block.minecraft.banner.stripe_center.yellow": "Geen Paal",
  "block.minecraft.banner.stripe_downleft.black": "Swart Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.blue": "Blou Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.brown": "Bruin Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.cyan": "Siaan Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.gray": "Grys Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.green": "Groen Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ligte Blou Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ligte Grys Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.lime": "Lemmetjie Groen Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.orange": "Oranje Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.pink": "Pienk Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.purple": "Pers Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.red": "Rooi Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.white": "Wit Sinistere Buig",
  "block.minecraft.banner.stripe_downleft.yellow": "Geen Sinistere Buig",
  "block.minecraft.banner.stripe_downright.black": "Die Swart Buiging",
  "block.minecraft.banner.stripe_downright.blue": "Blou Buig",
  "block.minecraft.banner.stripe_downright.brown": "Bruinbuig",
  "block.minecraft.banner.stripe_downright.cyan": "Blou Buig",
  "block.minecraft.banner.stripe_downright.gray": "Grys Bocht",
  "block.minecraft.banner.stripe_downright.green": "Die Groen Bocht",
  "block.minecraft.banner.stripe_downright.light_blue": "Ligte Blou Buig",
  "block.minecraft.banner.stripe_downright.light_gray": "Ligte Grys Buig",
  "block.minecraft.banner.stripe_downright.lime": "Lemmetjie Groen Buig",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Buig",
  "block.minecraft.banner.stripe_downright.orange": "Oranje Buig",
  "block.minecraft.banner.stripe_downright.pink": "Pienk Buig",
  "block.minecraft.banner.stripe_downright.purple": "Pers Buig",
  "block.minecraft.banner.stripe_downright.red": "Rooi Buig",
  "block.minecraft.banner.stripe_downright.white": "Wit Buig",
  "block.minecraft.banner.stripe_downright.yellow": "Geel Buig",
  "block.minecraft.banner.stripe_left.black": "Swart Paal Dexter",
  "block.minecraft.banner.stripe_left.blue": "Blou Paal Dexter",
  "block.minecraft.banner.stripe_left.brown": "Bruin Paal Dexter",
  "block.minecraft.banner.stripe_left.cyan": "Siaan Paal Dexter",
  "block.minecraft.banner.stripe_left.gray": "Grys Paal Dexter",
  "block.minecraft.banner.stripe_left.green": "Groen Paal Dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Ligte Blou Paal Dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Ligte Grys Paal Dexter",
  "block.minecraft.banner.stripe_left.lime": "Lemmetjie Groen Paal Dexter",
  "block.minecraft.banner.stripe_left.magenta": "Magenta Paal Dexter",
  "block.minecraft.banner.stripe_left.orange": "Oranje Paal Dexter",
  "block.minecraft.banner.stripe_left.pink": "Pienk Paal Dexter",
  "block.minecraft.banner.stripe_left.purple": "Pers Paal Dexter",
  "block.minecraft.banner.stripe_left.red": "Rooi Paal Dexter",
  "block.minecraft.banner.stripe_left.white": "Wit Paal Dexter",
  "block.minecraft.banner.stripe_left.yellow": "Geel Paal Dexter",
  "block.minecraft.banner.stripe_middle.black": "Swart Dwarsbalk",
  "block.minecraft.banner.stripe_middle.blue": "Blou Dwarsbalk",
  "block.minecraft.banner.stripe_middle.brown": "Bruin Dwarsbalk",
  "block.minecraft.banner.stripe_middle.cyan": "Blougroen Dwarsbalk",
  "block.minecraft.banner.stripe_middle.gray": "Grys Dwarsbalk",
  "block.minecraft.banner.stripe_middle.green": "Groen Dwarsbalk",
  "block.minecraft.banner.stripe_middle.light_blue": "Ligblou Dwarsbalk",
  "block.minecraft.banner.stripe_middle.light_gray": "Liggrys Dwarsbalk",
  "block.minecraft.banner.stripe_middle.lime": "Lemmetjie Dwarsbalk",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Dwarsbalk",
  "block.minecraft.banner.stripe_middle.orange": "Oranje Dwarsbalk",
  "block.minecraft.banner.stripe_middle.pink": "Pienk Dwarsbalk",
  "block.minecraft.banner.stripe_middle.purple": "Pers Dwarsbalk",
  "block.minecraft.banner.stripe_middle.red": "Rooi Dwarsbalk",
  "block.minecraft.banner.stripe_middle.white": "Wit Dwarsbalk",
  "block.minecraft.banner.stripe_middle.yellow": "Geel Dwarsbalk",
  "block.minecraft.banner.stripe_right.black": "Swart Paal Sinistere",
  "block.minecraft.banner.stripe_right.blue": "Blou Paal Sinistere",
  "block.minecraft.banner.stripe_right.brown": "Bruin Paal Sinistere",
  "block.minecraft.banner.stripe_right.cyan": "Siaan Paal Sinistere",
  "block.minecraft.banner.stripe_right.gray": "Grys Paal Sinistere",
  "block.minecraft.banner.stripe_right.green": "Groen Paal Sinistere",
  "block.minecraft.banner.stripe_right.light_blue": "Ligte Blou Paal Sinistere",
  "block.minecraft.banner.stripe_right.light_gray": "Ligte Grys Paal Sinistere",
  "block.minecraft.banner.stripe_right.lime": "Lemmetjie Groen Paal Sinistere",
  "block.minecraft.banner.stripe_right.magenta": "Magenta Paal Sinistere",
  "block.minecraft.banner.stripe_right.orange": "Oranje Paal Sinistere",
  "block.minecraft.banner.stripe_right.pink": "Pienk Paal Sinistere",
  "block.minecraft.banner.stripe_right.purple": "Pers Paal Sinistere",
  "block.minecraft.banner.stripe_right.red": "Rooi Paal Sinistere",
  "block.minecraft.banner.stripe_right.white": "Wit Paal Sinistere",
  "block.minecraft.banner.stripe_right.yellow": "Geen Paal Sinistere",
  "block.minecraft.banner.stripe_top.black": "Swart Hoof",
  "block.minecraft.banner.stripe_top.blue": "Blou Hoof",
  "block.minecraft.banner.stripe_top.brown": "Bruin Hoof",
  "block.minecraft.banner.stripe_top.cyan": "Siaan Hoof",
  "block.minecraft.banner.stripe_top.gray": "Grys Hoof",
  "block.minecraft.banner.stripe_top.green": "Groen Hoof",
  "block.minecraft.banner.stripe_top.light_blue": "Ligte Blou Hoof",
  "block.minecraft.banner.stripe_top.light_gray": "Ligte Grys Hoof",
  "block.minecraft.banner.stripe_top.lime": "Lemmetjie Groen Hoof",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Hoof",
  "block.minecraft.banner.stripe_top.orange": "Oranje Hoof",
  "block.minecraft.banner.stripe_top.pink": "Pienk Hoof",
  "block.minecraft.banner.stripe_top.purple": "Pers Hoof",
  "block.minecraft.banner.stripe_top.red": "Rooi Hoof",
  "block.minecraft.banner.stripe_top.white": "Wit Hoof",
  "block.minecraft.banner.stripe_top.yellow": "Geel Hoof",
  "block.minecraft.banner.triangle_bottom.black": "Swart Chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Blou Chevron",
  "block.minecraft.banner.triangle_bottom.brown": "Bruin Chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Siaan Chevron",
  "block.minecraft.banner.triangle_bottom.gray": "Grys Chevron",
  "block.minecraft.banner.triangle_bottom.green": "Groen Chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ligte Blou Chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ligte Grys Chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Lemmetjie Groen Chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta Chevron",
  "block.minecraft.banner.triangle_bottom.orange": "Oranje Chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Pienk Chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Pers Chevron",
  "block.minecraft.banner.triangle_bottom.red": "Rooi Chevron",
  "block.minecraft.banner.triangle_bottom.white": "Wit Chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "Geel Chevron",
  "block.minecraft.banner.triangle_top.black": "Swart Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.blue": "Blou Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.brown": "Bruin Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.cyan": "Siaan Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.gray": "Grys Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.green": "Groen Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.light_blue": "Ligte Blou Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Ligte Grys Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.lime": "Lemmetjie Groen Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.magenta": "Magenta Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.orange": "Oranje Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.pink": "Pienk Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.purple": "Pers Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.red": "Rooi Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.white": "Wit Omgekeerde Chevron",
  "block.minecraft.banner.triangle_top.yellow": "Geel Omgekeerde Chevron",
  "block.minecraft.banner.triangles_bottom.black": "Swart Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.blue": "Blou Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.brown": "Bruin Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.cyan": "Siaan Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.gray": "Grys Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.green": "Groen Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ligte Blou Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ligte Grys Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.lime": "Lemmetjie Groen Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.orange": "Oranje Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.pink": "Pienk Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.purple": "Pers Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.red": "Rooi Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.white": "Wit Ingekeepde Basis",
  "block.minecraft.banner.triangles_bottom.yellow": "Geen Ingekeepde Basis",
  "block.minecraft.banner.triangles_top.black": "Swart Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.blue": "Blou Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.brown": "Bruin Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.cyan": "Siaan Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.gray": "Grys Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.green": "Groen Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.light_blue": "Ligte Blou Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.light_gray": "Ligte Grys Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.lime": "Lemmetjie Groen Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.magenta": "Magenta Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.orange": "Oranje Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.pink": "Pienk Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.purple": "Pers Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.red": "Rooi Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.white": "Wit Ingekeepde Hoof",
  "block.minecraft.banner.triangles_top.yellow": "Geel Ingekeepde Hoof",
  "block.minecraft.barrel": "Vat",
  "block.minecraft.barrier": "Versperring",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Baken",
  "block.minecraft.beacon.primary": "Primêre Krag",
  "block.minecraft.beacon.secondary": "Sekondêre Krag",
  "block.minecraft.bed.no_sleep": "Jy kan net in die aand of tydens donderstorms slaap",
  "block.minecraft.bed.not_safe": "Jy mag nie nou rus nie; daar is monsters naby",
  "block.minecraft.bed.obstructed": "Hierdie bed is belemmer",
  "block.minecraft.bed.occupied": "Hierdie bed is beset",
  "block.minecraft.bed.too_far_away": "Jy mag nie nou rus nie, die bed is te vêr weg",
  "block.minecraft.bedrock": "Rotsbodem",
  "block.minecraft.bee_nest": "Byenes",
  "block.minecraft.beehive": "Byekorf",
  "block.minecraft.beetroots": "Beet",
  "block.minecraft.bell": "Klok",
  "block.minecraft.big_dripleaf": "Groot Drupblaar",
  "block.minecraft.big_dripleaf_stem": "Groot Drupblaar Stam",
  "block.minecraft.birch_button": "Berk Knoppie",
  "block.minecraft.birch_door": "Berkehout Deur",
  "block.minecraft.birch_fence": "Berkehou Heining",
  "block.minecraft.birch_fence_gate": "Berkehout Hek",
  "block.minecraft.birch_hanging_sign": "Berk hangende teken",
  "block.minecraft.birch_leaves": "Berkeblare",
  "block.minecraft.birch_log": "Berk Stomp",
  "block.minecraft.birch_planks": "Berk Planke",
  "block.minecraft.birch_pressure_plate": "Berk Drukplaat",
  "block.minecraft.birch_sapling": "Berkeboom Stiggie",
  "block.minecraft.birch_shelf": "Berk Rak",
  "block.minecraft.birch_sign": "Berkteken",
  "block.minecraft.birch_slab": "Berk Blad",
  "block.minecraft.birch_stairs": "Berk Trappe",
  "block.minecraft.birch_trapdoor": "Berk Valdeur",
  "block.minecraft.birch_wall_hanging_sign": "Berk muur hangende teken",
  "block.minecraft.birch_wall_sign": "Birch Muur Teken",
  "block.minecraft.birch_wood": "Berkehout",
  "block.minecraft.black_banner": "Swart Banier",
  "block.minecraft.black_bed": "Swart Bed",
  "block.minecraft.black_candle": "Swart Kersie",
  "block.minecraft.black_candle_cake": "Koek met Swart Kersie",
  "block.minecraft.black_carpet": "Swart Mat",
  "block.minecraft.black_concrete": "Swart Beton",
  "block.minecraft.black_concrete_powder": "Swart Beton Poeier",
  "block.minecraft.black_glazed_terracotta": "Swart Geglasuurde Terracotta",
  "block.minecraft.black_shulker_box": "Swart Shulker Boks",
  "block.minecraft.black_stained_glass": "Swart Glas",
  "block.minecraft.black_stained_glass_pane": "Swart Glaspaneel",
  "block.minecraft.black_terracotta": "Swart Terracotta",
  "block.minecraft.black_wool": "Swart Wol",
  "block.minecraft.blackstone": "Swartsteen",
  "block.minecraft.blackstone_slab": "Swartsteenblad",
  "block.minecraft.blackstone_stairs": "Swartsteentrappe",
  "block.minecraft.blackstone_wall": "Swartsteenmuur",
  "block.minecraft.blast_furnace": "Hoogoond",
  "block.minecraft.blue_banner": "Blou Vlag",
  "block.minecraft.blue_bed": "Blou Bed",
  "block.minecraft.blue_candle": "Blou Kersie",
  "block.minecraft.blue_candle_cake": "Koek met Blou Kersie",
  "block.minecraft.blue_carpet": "Blou Mat",
  "block.minecraft.blue_concrete": "Blou Beton",
  "block.minecraft.blue_concrete_powder": "Blou Beton Poeier",
  "block.minecraft.blue_glazed_terracotta": "Blou Geglasuurde Terracotta",
  "block.minecraft.blue_ice": "Blou Ys",
  "block.minecraft.blue_orchid": "Blou Orgideë",
  "block.minecraft.blue_shulker_box": "Blou Shulker Boks",
  "block.minecraft.blue_stained_glass": "Blou Glas",
  "block.minecraft.blue_stained_glass_pane": "Blou Glaspaneel",
  "block.minecraft.blue_terracotta": "Blou Terracotta",
  "block.minecraft.blue_wool": "Blou Wol",
  "block.minecraft.bone_block": "Beenblok",
  "block.minecraft.bookshelf": "Boekrak",
  "block.minecraft.brain_coral": "Breinkoraal",
  "block.minecraft.brain_coral_block": "Breinkoraal Blok",
  "block.minecraft.brain_coral_fan": "Gespreide Breinkoraal",
  "block.minecraft.brain_coral_wall_fan": "Muur-gespreide Breinkoraal",
  "block.minecraft.brewing_stand": "Retortstaander",
  "block.minecraft.brick_slab": "Baksteen Blad",
  "block.minecraft.brick_stairs": "Baksteen Trappe",
  "block.minecraft.brick_wall": "Baksteen Muur",
  "block.minecraft.bricks": "Bakstene",
  "block.minecraft.brown_banner": "Bruin Banier",
  "block.minecraft.brown_bed": "Bruin Bed",
  "block.minecraft.brown_candle": "Bruin Kersie",
  "block.minecraft.brown_candle_cake": "Koek met Bruin Kersie",
  "block.minecraft.brown_carpet": "Bruin Mat",
  "block.minecraft.brown_concrete": "Bruin Beton",
  "block.minecraft.brown_concrete_powder": "Bruin Beton Poeier",
  "block.minecraft.brown_glazed_terracotta": "Bruin Geglasuurde Terracotta",
  "block.minecraft.brown_mushroom": "Bruin Sampioen",
  "block.minecraft.brown_mushroom_block": "Bruin Sampioen Blok",
  "block.minecraft.brown_shulker_box": "Bruin Shulker Boks",
  "block.minecraft.brown_stained_glass": "Bruin Glas",
  "block.minecraft.brown_stained_glass_pane": "Bruin Glaspaneel",
  "block.minecraft.brown_terracotta": "Bruin Terracotta",
  "block.minecraft.brown_wool": "Bruin Wol",
  "block.minecraft.bubble_column": "Borrel pilaar",
  "block.minecraft.bubble_coral": "Borrelkoraal",
  "block.minecraft.bubble_coral_block": "Borrelkoraal Blok",
  "block.minecraft.bubble_coral_fan": "Gespreide Borrelkoraal",
  "block.minecraft.bubble_coral_wall_fan": "Muur-gespreide Borrelkoraal",
  "block.minecraft.budding_amethyst": "Ontluikende Ametis",
  "block.minecraft.bush": "Bossie",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblom",
  "block.minecraft.cake": "Koek",
  "block.minecraft.calcite": "Kalsiet",
  "block.minecraft.calibrated_sculk_sensor": "Gekalibreerde Sculk Sensor",
  "block.minecraft.campfire": "Kampvuur",
  "block.minecraft.candle": "Kers",
  "block.minecraft.candle_cake": "Koek met kers rester",
  "block.minecraft.carrots": "Wortels",
  "block.minecraft.cartography_table": "Kartografie Tafel",
  "block.minecraft.carved_pumpkin": "Gekerf Pampoen",
  "block.minecraft.cauldron": "Kookpot",
  "block.minecraft.cave_air": "Grot Lug",
  "block.minecraft.cave_vines": "Grot Ranke",
  "block.minecraft.cave_vines_plant": "Grot Rank Plante",
  "block.minecraft.chain": "Ketting",
  "block.minecraft.chain_command_block": "Ketting Opdragblok",
  "block.minecraft.cherry_button": "Kersie Knoppie",
  "block.minecraft.cherry_door": "Kersie Deur",
  "block.minecraft.cherry_fence": "Kersieheining",
  "block.minecraft.cherry_fence_gate": "Kersie Heining Hek",
  "block.minecraft.cherry_hanging_sign": "Kersie Hang Teken",
  "block.minecraft.cherry_leaves": "Kersieblare",
  "block.minecraft.cherry_log": "Kersie-Stok",
  "block.minecraft.cherry_planks": "Kersieplanke",
  "block.minecraft.cherry_pressure_plate": "Cherry Druk Plaat",
  "block.minecraft.cherry_sapling": "Kersie Sapling",
  "block.minecraft.cherry_shelf": "Kersie Rak",
  "block.minecraft.cherry_sign": "Kersie Teken",
  "block.minecraft.cherry_slab": "Kersie-Plaat",
  "block.minecraft.cherry_stairs": "Kersie Trappe",
  "block.minecraft.cherry_trapdoor": "Kersie Valdeur",
  "block.minecraft.cherry_wall_hanging_sign": "Kersie Muur Hang Teken",
  "block.minecraft.cherry_wall_sign": "Kersie Muur Teken",
  "block.minecraft.cherry_wood": "Kersiehout",
  "block.minecraft.chest": "Kis",
  "block.minecraft.chipped_anvil": "Gekapte Aambeeld",
  "block.minecraft.chiseled_bookshelf": "Gebeitelde boekrak",
  "block.minecraft.chiseled_copper": "Chizod Kappa",
  "block.minecraft.chiseled_deepslate": "Afgewerkte Leisteen",
  "block.minecraft.chiseled_nether_bricks": "Afgewerkde Laer Bakstene",
  "block.minecraft.chiseled_polished_blackstone": "Afgewerkte Gepoleerde Swartsteen",
  "block.minecraft.chiseled_quartz_block": "Afgewerkde Kwartsblok",
  "block.minecraft.chiseled_red_sandstone": "Afgewerkte Rooi Sandsteen",
  "block.minecraft.chiseled_resin_bricks": "Gebeitelde Hars Bakstene",
  "block.minecraft.chiseled_sandstone": "Afgewerkte Sandsteen",
  "block.minecraft.chiseled_stone_bricks": "Afgewerkte Klipstene",
  "block.minecraft.chiseled_tuff": "Gebeitelde Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Gebeitelde Tuff-stene",
  "block.minecraft.chorus_flower": "Refrein Blom",
  "block.minecraft.chorus_plant": "Refrein Plant",
  "block.minecraft.clay": "Klei",
  "block.minecraft.closed_eyeblossom": "Toegemaakte Oogbloeisel",
  "block.minecraft.coal_block": "Steenkoolblok",
  "block.minecraft.coal_ore": "Steenkool Erts",
  "block.minecraft.coarse_dirt": "Growwe Grond",
  "block.minecraft.cobbled_deepslate": "Leisteengruis",
  "block.minecraft.cobbled_deepslate_slab": "Leisteengruis-blad",
  "block.minecraft.cobbled_deepslate_stairs": "Leisteengruis-trappe",
  "block.minecraft.cobbled_deepslate_wall": "Leisteengruis-muur",
  "block.minecraft.cobblestone": "Steengruis",
  "block.minecraft.cobblestone_slab": "Steengruisblad",
  "block.minecraft.cobblestone_stairs": "Steengruis Trappe",
  "block.minecraft.cobblestone_wall": "Steengruis Muur",
  "block.minecraft.cobweb": "Spinnerak",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Opdragblok",
  "block.minecraft.comparator": "Redstone Vergelyker",
  "block.minecraft.composter": "Komposmaker",
  "block.minecraft.conduit": "Watervoor",
  "block.minecraft.copper_bars": "Koper Tralies",
  "block.minecraft.copper_block": "Koperblok",
  "block.minecraft.copper_bulb": "Koper gloeilamp",
  "block.minecraft.copper_chain": "Koper Ketting",
  "block.minecraft.copper_chest": "Koper Kus",
  "block.minecraft.copper_door": "Koperdeur",
  "block.minecraft.copper_golem_statue": "Koper Golem Standbeeld",
  "block.minecraft.copper_grate": "Koperrooster",
  "block.minecraft.copper_lantern": "Koper Lantern",
  "block.minecraft.copper_ore": "Koper Erts",
  "block.minecraft.copper_torch": "Koper Fakkel",
  "block.minecraft.copper_trapdoor": "Koper valdeur",
  "block.minecraft.copper_wall_torch": "Koper Muur Fakkel",
  "block.minecraft.cornflower": "Koringblom",
  "block.minecraft.cracked_deepslate_bricks": "Gekraakte Leisteen Bakstene",
  "block.minecraft.cracked_deepslate_tiles": "Gekraakte Leisteenteëls",
  "block.minecraft.cracked_nether_bricks": "Gekraakte Laer Bakstene",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gekraakte Gepoleerde Swartsteen Bakstene",
  "block.minecraft.cracked_stone_bricks": "Gekraakte Klipstene",
  "block.minecraft.crafter": "Vervaardiger",
  "block.minecraft.crafting_table": "Werksbank",
  "block.minecraft.creaking_heart": "Creaking Hart",
  "block.minecraft.creeper_head": "Creeper Kop",
  "block.minecraft.creeper_wall_head": "Creeper Muur Kop",
  "block.minecraft.crimson_button": "Bloedrooi Knoppie",
  "block.minecraft.crimson_door": "Bloedrooi Deur",
  "block.minecraft.crimson_fence": "Bloedrooi Heining",
  "block.minecraft.crimson_fence_gate": "Bloedrooi Hek",
  "block.minecraft.crimson_fungus": "Bloedrooi Swam",
  "block.minecraft.crimson_hanging_sign": "Karmosyn Hangende Teken",
  "block.minecraft.crimson_hyphae": "Bloedrooi Styfstrepe",
  "block.minecraft.crimson_nylium": "Bloedrooi Laelium",
  "block.minecraft.crimson_planks": "Bloedrooi Planke",
  "block.minecraft.crimson_pressure_plate": "Bloedrooi Drukplaat",
  "block.minecraft.crimson_roots": "Bloedrooi Wortels",
  "block.minecraft.crimson_shelf": "Bloedrooi Rak",
  "block.minecraft.crimson_sign": "Bloedrooi Bord",
  "block.minecraft.crimson_slab": "Bloedrooi Blad",
  "block.minecraft.crimson_stairs": "Bloedrooi Trappe",
  "block.minecraft.crimson_stem": "Bloedrooi Steel",
  "block.minecraft.crimson_trapdoor": "Bloedrooi Valdeur",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Muurhangende Teken",
  "block.minecraft.crimson_wall_sign": "Bloedrooi Muurbord",
  "block.minecraft.crying_obsidian": "Huilende Obsidiaan",
  "block.minecraft.cut_copper": "Gesnyde Koper",
  "block.minecraft.cut_copper_slab": "Gesnyde Koper Blad",
  "block.minecraft.cut_copper_stairs": "Gesnyde Koper Trap",
  "block.minecraft.cut_red_sandstone": "Gesnyde Rooi Sandsteen",
  "block.minecraft.cut_red_sandstone_slab": "Sny Rooi Sandsteenblaar",
  "block.minecraft.cut_sandstone": "Gesnyde Sandsteen",
  "block.minecraft.cut_sandstone_slab": "Sny Sandsteenplaat",
  "block.minecraft.cyan_banner": "Siaan Vlag",
  "block.minecraft.cyan_bed": "Siaan Bed",
  "block.minecraft.cyan_candle": "Blougroen Kersie",
  "block.minecraft.cyan_candle_cake": "Koek met Blougroen Kersie",
  "block.minecraft.cyan_carpet": "Blougroen Mat",
  "block.minecraft.cyan_concrete": "Blougroen Beton",
  "block.minecraft.cyan_concrete_powder": "Blougroen Beton Poeier",
  "block.minecraft.cyan_glazed_terracotta": "Blougroen Geglasuurde Terracotta",
  "block.minecraft.cyan_shulker_box": "Blougroen Shulkerboks",
  "block.minecraft.cyan_stained_glass": "Blougroen Glas",
  "block.minecraft.cyan_stained_glass_pane": "Blougroen Gekleurde Glaspaneel",
  "block.minecraft.cyan_terracotta": "Blougroen Terracotta",
  "block.minecraft.cyan_wool": "Blougroen Wol",
  "block.minecraft.damaged_anvil": "Beskadigde Aambeeld",
  "block.minecraft.dandelion": "Perdeblom",
  "block.minecraft.dark_oak_button": "Donker Eikehout Knoppie",
  "block.minecraft.dark_oak_door": "Donker Eikehout Deur",
  "block.minecraft.dark_oak_fence": "Donker Eikehout Heining",
  "block.minecraft.dark_oak_fence_gate": "Donker Eikehout Hek",
  "block.minecraft.dark_oak_hanging_sign": "Donker eikehout hangende bord",
  "block.minecraft.dark_oak_leaves": "Donker Eikeboomblare",
  "block.minecraft.dark_oak_log": "Donker Eikehout Stomp",
  "block.minecraft.dark_oak_planks": "Donker Eikehout Planke",
  "block.minecraft.dark_oak_pressure_plate": "Donker Eikehout Drukplaat",
  "block.minecraft.dark_oak_sapling": "Donker Eikeboom Stiggie",
  "block.minecraft.dark_oak_shelf": "Donker Eikehout Kas",
  "block.minecraft.dark_oak_sign": "Donker Oak Teken",
  "block.minecraft.dark_oak_slab": "Donker Eikehout Blad",
  "block.minecraft.dark_oak_stairs": "Donker Eikehout Trappe",
  "block.minecraft.dark_oak_trapdoor": "Donker Eikehout Valdeur",
  "block.minecraft.dark_oak_wall_hanging_sign": "Donker Eikehout Muurhangende Teken",
  "block.minecraft.dark_oak_wall_sign": "Dark Oak Muur Teken",
  "block.minecraft.dark_oak_wood": "Donker Eikehout",
  "block.minecraft.dark_prismarine": "Donker Prismaryn",
  "block.minecraft.dark_prismarine_slab": "Donker Prismaryn blad",
  "block.minecraft.dark_prismarine_stairs": "Donker Prismaryn Trappe",
  "block.minecraft.daylight_detector": "Daglig Sensor",
  "block.minecraft.dead_brain_coral": "Dooie Breinkoraal",
  "block.minecraft.dead_brain_coral_block": "Dooie Breinkoraal Blok",
  "block.minecraft.dead_brain_coral_fan": "Dooie Gespreide Breinkoraal",
  "block.minecraft.dead_brain_coral_wall_fan": "Dooie Muur-gespreide Breinkoraal",
  "block.minecraft.dead_bubble_coral": "Dooie Borrelkoraal",
  "block.minecraft.dead_bubble_coral_block": "Dooie Borrelkoraal Blok",
  "block.minecraft.dead_bubble_coral_fan": "Dooie Gespreide Borrelkoraal",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dooie Muur-gespreide Borrelkoraal",
  "block.minecraft.dead_bush": "Dooie Bos",
  "block.minecraft.dead_fire_coral": "Dooie Vlamkoraal",
  "block.minecraft.dead_fire_coral_block": "Dooie Vlamkoraal Blok",
  "block.minecraft.dead_fire_coral_fan": "Dooie Gespreide Vlamkoraal",
  "block.minecraft.dead_fire_coral_wall_fan": "Dooie Muur-gespreide Vlamkoraal",
  "block.minecraft.dead_horn_coral": "Dooie Horingkoraal",
  "block.minecraft.dead_horn_coral_block": "Dooie Horingkoraal Blok",
  "block.minecraft.dead_horn_coral_fan": "Dooie Gespreide Horingkoraal",
  "block.minecraft.dead_horn_coral_wall_fan": "Dooie Muur-gespreide Horingkoraal",
  "block.minecraft.dead_tube_coral": "Dooie Buiskoraal",
  "block.minecraft.dead_tube_coral_block": "Dooie Buiskoraal Blok",
  "block.minecraft.dead_tube_coral_fan": "Dooie Gespreide Buiskoraal",
  "block.minecraft.dead_tube_coral_wall_fan": "Dooie Muur-gespreide Buiskoraal",
  "block.minecraft.decorated_pot": "Versierde Pot",
  "block.minecraft.deepslate": "Leisteen",
  "block.minecraft.deepslate_brick_slab": "Leisteen Baksteenblad",
  "block.minecraft.deepslate_brick_stairs": "Leisteen Baksteentrappe",
  "block.minecraft.deepslate_brick_wall": "Leisteen Baksteenmuur",
  "block.minecraft.deepslate_bricks": "Leisteen Bakstene",
  "block.minecraft.deepslate_coal_ore": "Leisteen Steenkool-erts",
  "block.minecraft.deepslate_copper_ore": "Leisteen Kopererts",
  "block.minecraft.deepslate_diamond_ore": "Leisteen Diamanterts",
  "block.minecraft.deepslate_emerald_ore": "Leisteen Smarag-erts",
  "block.minecraft.deepslate_gold_ore": "Leisteen Gouderts",
  "block.minecraft.deepslate_iron_ore": "Leisteen Ystererts",
  "block.minecraft.deepslate_lapis_ore": "Leisteen Lasuur-erts",
  "block.minecraft.deepslate_redstone_ore": "Leisteen Redstone-erts",
  "block.minecraft.deepslate_tile_slab": "Leisteenteëlblad",
  "block.minecraft.deepslate_tile_stairs": "Leisteenteëltrappe",
  "block.minecraft.deepslate_tile_wall": "Leisteenteëlmuur",
  "block.minecraft.deepslate_tiles": "Leisteenteëls",
  "block.minecraft.detector_rail": "Seinspoor",
  "block.minecraft.diamond_block": "Diamantblok",
  "block.minecraft.diamond_ore": "Diamanterts",
  "block.minecraft.diorite": "Dioriet",
  "block.minecraft.diorite_slab": "Dioriet Blad",
  "block.minecraft.diorite_stairs": "Diorit Trappe",
  "block.minecraft.diorite_wall": "Dioriet Muur",
  "block.minecraft.dirt": "Grond",
  "block.minecraft.dirt_path": "Grondpad",
  "block.minecraft.dispenser": "Uitdeler",
  "block.minecraft.dragon_egg": "Draak Eier",
  "block.minecraft.dragon_head": "Draak Kop",
  "block.minecraft.dragon_wall_head": "Draak Muur Kop",
  "block.minecraft.dried_ghast": "Gedroogde Ghast",
  "block.minecraft.dried_kelp_block": "Gedroogde Kelp Blok",
  "block.minecraft.dripstone_block": "Drupsteen blok",
  "block.minecraft.dropper": "Leweraar",
  "block.minecraft.emerald_block": "Smaragblok",
  "block.minecraft.emerald_ore": "Smarag-Erts",
  "block.minecraft.enchanting_table": "Betoweringtafel",
  "block.minecraft.end_gateway": "Eind Hekgang",
  "block.minecraft.end_portal": "Einde Portaal",
  "block.minecraft.end_portal_frame": "Laer Ingang Raam",
  "block.minecraft.end_rod": "Endstaaf",
  "block.minecraft.end_stone": "Endsteen",
  "block.minecraft.end_stone_brick_slab": "Eind Baksteen Blad",
  "block.minecraft.end_stone_brick_stairs": "Eind Baksteen Trappe",
  "block.minecraft.end_stone_brick_wall": "Eindbaksteen Muur",
  "block.minecraft.end_stone_bricks": "Endsteen Bakstene",
  "block.minecraft.ender_chest": "Ender Kis",
  "block.minecraft.exposed_chiseled_copper": "Ontblote gebeitelde koper",
  "block.minecraft.exposed_copper": "Blootgestelde Koperblok",
  "block.minecraft.exposed_copper_bars": "Blootgestelde Koper Tralies",
  "block.minecraft.exposed_copper_bulb": "Blootgestelde koperbol",
  "block.minecraft.exposed_copper_chain": "Blootgestelde Koper Ketting",
  "block.minecraft.exposed_copper_chest": "Blootgestelde Koper Kus",
  "block.minecraft.exposed_copper_door": "Blootgestelde koperdeur",
  "block.minecraft.exposed_copper_golem_statue": "Blootgestelde Koper Golem Standbeeld",
  "block.minecraft.exposed_copper_grate": "Blootgestelde koperrooster",
  "block.minecraft.exposed_copper_lantern": "Blootgestelde Koper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Blootgestelde koper valdeur",
  "block.minecraft.exposed_cut_copper": "Ontblote Gesnyde Koperblok",
  "block.minecraft.exposed_cut_copper_slab": "Blootgestelde Gesnyde Koperblad",
  "block.minecraft.exposed_cut_copper_stairs": "Bloodgestelde Gesnyde Kopertrappe",
  "block.minecraft.exposed_lightning_rod": "Blootgestelde Weerlig Staaf",
  "block.minecraft.farmland": "Landbougrond",
  "block.minecraft.fern": "Varing",
  "block.minecraft.fire": "Vuur",
  "block.minecraft.fire_coral": "Vlamkoraal",
  "block.minecraft.fire_coral_block": "Vlamkoraal Blok",
  "block.minecraft.fire_coral_fan": "Gespreide Vlamkoraal",
  "block.minecraft.fire_coral_wall_fan": "Gespreide Vlamkoraal",
  "block.minecraft.firefly_bush": "Vuurvliegiebos",
  "block.minecraft.fletching_table": "Fletching Tafel",
  "block.minecraft.flower_pot": "Blompot",
  "block.minecraft.flowering_azalea": "Blomdraende Azalea",
  "block.minecraft.flowering_azalea_leaves": "Blomdraende Azalea Blare",
  "block.minecraft.frogspawn": "Paddaspawn",
  "block.minecraft.frosted_ice": "Gevriesde Ys",
  "block.minecraft.furnace": "Oond",
  "block.minecraft.gilded_blackstone": "Vergulde Swartsteen",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glaspaneel",
  "block.minecraft.glow_lichen": "Gloeiende Korsmos",
  "block.minecraft.glowstone": "Gloeisteen",
  "block.minecraft.gold_block": "Goudblok",
  "block.minecraft.gold_ore": "Gouderts",
  "block.minecraft.golden_dandelion": "Goudelike Sonneblom",
  "block.minecraft.granite": "Graniet",
  "block.minecraft.granite_slab": "Granietblad",
  "block.minecraft.granite_stairs": "Graniet Trappe",
  "block.minecraft.granite_wall": "Graniet Muur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblok",
  "block.minecraft.gravel": "Gruis",
  "block.minecraft.gray_banner": "Grys Banier",
  "block.minecraft.gray_bed": "Grys Bed",
  "block.minecraft.gray_candle": "Grys Kers",
  "block.minecraft.gray_candle_cake": "Koek met Grys Kersie",
  "block.minecraft.gray_carpet": "Grys Mat",
  "block.minecraft.gray_concrete": "Grys Beton",
  "block.minecraft.gray_concrete_powder": "Grys Beton Poeier",
  "block.minecraft.gray_glazed_terracotta": "Grys Geglasuurde Terracotta",
  "block.minecraft.gray_shulker_box": "Grys Shulker Boks",
  "block.minecraft.gray_stained_glass": "Grys Glas",
  "block.minecraft.gray_stained_glass_pane": "Grys Gekleurde Glaspaneel",
  "block.minecraft.gray_terracotta": "Grys Terracotta",
  "block.minecraft.gray_wool": "Grys Wol",
  "block.minecraft.green_banner": "Groen Banier",
  "block.minecraft.green_bed": "Groen Bed",
  "block.minecraft.green_candle": "Groen Kersie",
  "block.minecraft.green_candle_cake": "Koek met Groen Kersie",
  "block.minecraft.green_carpet": "Groen Mat",
  "block.minecraft.green_concrete": "Groen Beton",
  "block.minecraft.green_concrete_powder": "Groen Beton Poeier",
  "block.minecraft.green_glazed_terracotta": "Groen Geglasuurde Terracotta",
  "block.minecraft.green_shulker_box": "Groen Shulker Boks",
  "block.minecraft.green_stained_glass": "Groen Glas",
  "block.minecraft.green_stained_glass_pane": "Groen Glaspaneel",
  "block.minecraft.green_terracotta": "Groen Terracotta",
  "block.minecraft.green_wool": "Groen Wol",
  "block.minecraft.grindstone": "Slypsteen",
  "block.minecraft.hanging_roots": "Hangende wortels",
  "block.minecraft.hay_block": "Hooibaal",
  "block.minecraft.heavy_core": "Swaar kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Swaar Geweegde Druk Plaat",
  "block.minecraft.honey_block": "Heuningblok",
  "block.minecraft.honeycomb_block": "Heuningkoekblok",
  "block.minecraft.hopper": "Geutbak",
  "block.minecraft.horn_coral": "Horingkoraal",
  "block.minecraft.horn_coral_block": "Horingkoraal Blok",
  "block.minecraft.horn_coral_fan": "Gespreide Horingkoraal",
  "block.minecraft.horn_coral_wall_fan": "Muur-gespreide Horingkoraal",
  "block.minecraft.ice": "Ys",
  "block.minecraft.infested_chiseled_stone_bricks": "Besmette Afgewerkte Klipstene",
  "block.minecraft.infested_cobblestone": "Besmette Geplaveide",
  "block.minecraft.infested_cracked_stone_bricks": "Besmette Gekraakte Klipstene",
  "block.minecraft.infested_deepslate": "Besmette Leisteen",
  "block.minecraft.infested_mossy_stone_bricks": "Besmette Mossige Klipstene",
  "block.minecraft.infested_stone": "Besmette Klip",
  "block.minecraft.infested_stone_bricks": "Besmette Klipstene",
  "block.minecraft.iron_bars": "Yster Stawe",
  "block.minecraft.iron_block": "Ysterblok",
  "block.minecraft.iron_chain": "Yster Ketting",
  "block.minecraft.iron_door": "Yster Deur",
  "block.minecraft.iron_ore": "Ystererts",
  "block.minecraft.iron_trapdoor": "Yster Valdeur",
  "block.minecraft.jack_o_lantern": "Pampoenspook",
  "block.minecraft.jigsaw": "Legkaart Blok",
  "block.minecraft.jukebox": "Musiekspeler",
  "block.minecraft.jungle_button": "Oerwoudhout Knoppie",
  "block.minecraft.jungle_door": "Mahoniehout Deur",
  "block.minecraft.jungle_fence": "Mahoniehout Heining",
  "block.minecraft.jungle_fence_gate": "Mahoniehout Hek",
  "block.minecraft.jungle_hanging_sign": "Oerwoud Hangende Teken",
  "block.minecraft.jungle_leaves": "Mahonieblare",
  "block.minecraft.jungle_log": "Oerwoudhout Stomp",
  "block.minecraft.jungle_planks": "Oerwoudhout Planke",
  "block.minecraft.jungle_pressure_plate": "Oerwoudhout Drukplaat",
  "block.minecraft.jungle_sapling": "Mahonieboom Stiggie",
  "block.minecraft.jungle_shelf": "Oerwoud Rak",
  "block.minecraft.jungle_sign": "Jungle Teken",
  "block.minecraft.jungle_slab": "Oerwoudhout Blad",
  "block.minecraft.jungle_stairs": "Oerwoudhout Trappe",
  "block.minecraft.jungle_trapdoor": "Oerwoudhout Valdeur",
  "block.minecraft.jungle_wall_hanging_sign": "Oerwoud Muur Hangende Teken",
  "block.minecraft.jungle_wall_sign": "Oerwoud Muur Teken",
  "block.minecraft.jungle_wood": "Mahoniehout",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelp plant",
  "block.minecraft.ladder": "Leer",
  "block.minecraft.lantern": "Lantern",
  "block.minecraft.lapis_block": "Lasuursteenblok",
  "block.minecraft.lapis_ore": "Lasuurerts",
  "block.minecraft.large_amethyst_bud": "Groot Ametis Knoppie",
  "block.minecraft.large_fern": "Groot Varing",
  "block.minecraft.lava": "Lawa",
  "block.minecraft.lava_cauldron": "Lawaketel",
  "block.minecraft.leaf_litter": "Blaarrommel",
  "block.minecraft.lectern": "Lessenaar",
  "block.minecraft.lever": "Skakelaar",
  "block.minecraft.light": "Lig",
  "block.minecraft.light_blue_banner": "Ligblou Banier",
  "block.minecraft.light_blue_bed": "Ligte blou Bed",
  "block.minecraft.light_blue_candle": "Ligte Blou Kers",
  "block.minecraft.light_blue_candle_cake": "Koek met Ligblou Kersie",
  "block.minecraft.light_blue_carpet": "Ligblou Mat",
  "block.minecraft.light_blue_concrete": "Ligte Blou Beton",
  "block.minecraft.light_blue_concrete_powder": "Ligblou Beton Poeier",
  "block.minecraft.light_blue_glazed_terracotta": "Ligte Blou Geglasuurde Terracotta",
  "block.minecraft.light_blue_shulker_box": "Ligte Blou Shulker Boks",
  "block.minecraft.light_blue_stained_glass": "Ligblou Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Ligblou Gekleurde Glaspaneel",
  "block.minecraft.light_blue_terracotta": "Ligblou Terracotta",
  "block.minecraft.light_blue_wool": "Ligblou Wol",
  "block.minecraft.light_gray_banner": "Ligtegrys Vlag",
  "block.minecraft.light_gray_bed": "Ligte grys Bed",
  "block.minecraft.light_gray_candle": "Ligte Grys Kers",
  "block.minecraft.light_gray_candle_cake": "Koek met Lig Grys Kersie",
  "block.minecraft.light_gray_carpet": "Liggrys Mat",
  "block.minecraft.light_gray_concrete": "Ligte Grys Beton",
  "block.minecraft.light_gray_concrete_powder": "Liggrys Beton Poeier",
  "block.minecraft.light_gray_glazed_terracotta": "Ligte Grys Geglasuurde Terracotta",
  "block.minecraft.light_gray_shulker_box": "Ligte Grys Shulker Boks",
  "block.minecraft.light_gray_stained_glass": "Liggrys Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Liggrys Gekleurde Glaspaneel",
  "block.minecraft.light_gray_terracotta": "Liggrys Terracotta",
  "block.minecraft.light_gray_wool": "Liggrys Wol",
  "block.minecraft.light_weighted_pressure_plate": "Ligte Geweegde Druk Plaat",
  "block.minecraft.lightning_rod": "Weerlig paal",
  "block.minecraft.lilac": "Tuinsering",
  "block.minecraft.lily_of_the_valley": "Lelie van die Vallei",
  "block.minecraft.lily_pad": "Lelieblaar",
  "block.minecraft.lime_banner": "Heldergroen Banier",
  "block.minecraft.lime_bed": "Lemmetjie groen bed",
  "block.minecraft.lime_candle": "Liggroen Kers",
  "block.minecraft.lime_candle_cake": "Koek met Liggroen Kersie",
  "block.minecraft.lime_carpet": "Heldergroen Mat",
  "block.minecraft.lime_concrete": "Lemmetjie Groen Beton",
  "block.minecraft.lime_concrete_powder": "Lemmetjie Groen Beton Poeier",
  "block.minecraft.lime_glazed_terracotta": "Lemmetjie Groen Geglasuurde Terracotta",
  "block.minecraft.lime_shulker_box": "Lemmetjie Groen Shulker boks",
  "block.minecraft.lime_stained_glass": "Heldergroen Glas",
  "block.minecraft.lime_stained_glass_pane": "Liggroen Gekleurde Glaspaneel",
  "block.minecraft.lime_terracotta": "Lemmetjie Groen Terracotta",
  "block.minecraft.lime_wool": "Heldergroen Wol",
  "block.minecraft.lodestone": "Seilsteen",
  "block.minecraft.loom": "Weefstoel",
  "block.minecraft.magenta_banner": "Purperrooi Banier",
  "block.minecraft.magenta_bed": "Magenta Bed",
  "block.minecraft.magenta_candle": "Magenta Kers",
  "block.minecraft.magenta_candle_cake": "Koek met Magenta Kersie",
  "block.minecraft.magenta_carpet": "Magenta Mat",
  "block.minecraft.magenta_concrete": "Magenta Beton",
  "block.minecraft.magenta_concrete_powder": "Magenta Beton Poeier",
  "block.minecraft.magenta_glazed_terracotta": "Magenta Geglasuurde Terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker Boks",
  "block.minecraft.magenta_stained_glass": "Magenta Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Gekleurde Glaspaneel",
  "block.minecraft.magenta_terracotta": "Magenta Terracotta",
  "block.minecraft.magenta_wool": "Magenta Wol",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrove Knoppie",
  "block.minecraft.mangrove_door": "Mangrove Deur",
  "block.minecraft.mangrove_fence": "Mangrove Heining",
  "block.minecraft.mangrove_fence_gate": "Mangrove Hek",
  "block.minecraft.mangrove_hanging_sign": "Mangrove Hang Teken",
  "block.minecraft.mangrove_leaves": "Mangrove Blare",
  "block.minecraft.mangrove_log": "Mangrove Log",
  "block.minecraft.mangrove_planks": "Mangrove Planke",
  "block.minecraft.mangrove_pressure_plate": "Mangrove Drukplaat",
  "block.minecraft.mangrove_propagule": "Mangrove Voortplanting",
  "block.minecraft.mangrove_roots": "Mangrove Wortels",
  "block.minecraft.mangrove_shelf": "Wortelboom Rak",
  "block.minecraft.mangrove_sign": "Mangrove Teken",
  "block.minecraft.mangrove_slab": "Mangrove Blad",
  "block.minecraft.mangrove_stairs": "Mangrove Trappe",
  "block.minecraft.mangrove_trapdoor": "Mangrove Valdeur",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Muurhangende Teken",
  "block.minecraft.mangrove_wall_sign": "Mangrove Muur Teken",
  "block.minecraft.mangrove_wood": "Mangrove Hout",
  "block.minecraft.medium_amethyst_bud": "Medium Ametisknoppie",
  "block.minecraft.melon": "Waatlemoen",
  "block.minecraft.melon_stem": "Waatlemoenstam",
  "block.minecraft.moss_block": "Mos blok",
  "block.minecraft.moss_carpet": "Mosmat",
  "block.minecraft.mossy_cobblestone": "Mossige Geplaveide",
  "block.minecraft.mossy_cobblestone_slab": "Mossige Geplaveide Blad",
  "block.minecraft.mossy_cobblestone_stairs": "Mossige Geplaveide Trappe",
  "block.minecraft.mossy_cobblestone_wall": "Mossige Steengruis Muur",
  "block.minecraft.mossy_stone_brick_slab": "Mossige Klip Baksteen Blad",
  "block.minecraft.mossy_stone_brick_stairs": "Mossige Klip Baksteen Trappe",
  "block.minecraft.mossy_stone_brick_wall": "Mossige Steen Baksteen Muur",
  "block.minecraft.mossy_stone_bricks": "Mossige Klipstene",
  "block.minecraft.moving_piston": "Bewegende Suier",
  "block.minecraft.mud": "Modder",
  "block.minecraft.mud_brick_slab": "Modder Steen Blad",
  "block.minecraft.mud_brick_stairs": "Modder Steen Trappe",
  "block.minecraft.mud_brick_wall": "Modder Steen Muur",
  "block.minecraft.mud_bricks": "Modder Stene",
  "block.minecraft.muddy_mangrove_roots": "Modder Mangrove Wortels",
  "block.minecraft.mushroom_stem": "Sampioen Stengel",
  "block.minecraft.mycelium": "Miselium",
  "block.minecraft.nether_brick_fence": "Netherbaksteen Heining",
  "block.minecraft.nether_brick_slab": "Nether Baksteenblad",
  "block.minecraft.nether_brick_stairs": "Nether Baksteen-Trappe",
  "block.minecraft.nether_brick_wall": "Laer Baksteen Muur",
  "block.minecraft.nether_bricks": "Laer Bakstene",
  "block.minecraft.nether_gold_ore": "Laer Gouderts",
  "block.minecraft.nether_portal": "Laer Ingang",
  "block.minecraft.nether_quartz_ore": "Nether Kwartserts",
  "block.minecraft.nether_sprouts": "Laer Spruite",
  "block.minecraft.nether_wart": "Netherwortel",
  "block.minecraft.nether_wart_block": "Netherwortelblok",
  "block.minecraft.netherite_block": "Blok van Laeriet",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nootblok",
  "block.minecraft.oak_button": "Eikehout Knoppie",
  "block.minecraft.oak_door": "Eikehout Deur",
  "block.minecraft.oak_fence": "Eikehout Heining",
  "block.minecraft.oak_fence_gate": "Eikehout Hek",
  "block.minecraft.oak_hanging_sign": "Eik hangende bord",
  "block.minecraft.oak_leaves": "Eikeblare",
  "block.minecraft.oak_log": "Eikehout Stomp",
  "block.minecraft.oak_planks": "Eikehout Planke",
  "block.minecraft.oak_pressure_plate": "Eikehout Drukplaat",
  "block.minecraft.oak_sapling": "Eikeboom Stiggie",
  "block.minecraft.oak_shelf": "Eikehout Rak",
  "block.minecraft.oak_sign": "Eiken bord",
  "block.minecraft.oak_slab": "Eikehout Blad",
  "block.minecraft.oak_stairs": "Eikehout Trappe",
  "block.minecraft.oak_trapdoor": "Eikehout Trapdoor",
  "block.minecraft.oak_wall_hanging_sign": "Eike muur hangende teken",
  "block.minecraft.oak_wall_sign": "Eiken Muur Teken",
  "block.minecraft.oak_wood": "Eikehout",
  "block.minecraft.observer": "Waarnemer",
  "block.minecraft.obsidian": "Lawaglas",
  "block.minecraft.ochre_froglight": "Oker Paddalig",
  "block.minecraft.ominous_banner": "Onheilspellende Banier",
  "block.minecraft.open_eyeblossom": "Oop Oogbloeisel",
  "block.minecraft.orange_banner": "Oranje Banier",
  "block.minecraft.orange_bed": "Oranje Bed",
  "block.minecraft.orange_candle": "Oranje Kers",
  "block.minecraft.orange_candle_cake": "Koek met Oranje Kersie",
  "block.minecraft.orange_carpet": "Oranje Mat",
  "block.minecraft.orange_concrete": "Oranje Beton",
  "block.minecraft.orange_concrete_powder": "Oranje Beton Poeier",
  "block.minecraft.orange_glazed_terracotta": "Oranje Geglasuurde Terracotta",
  "block.minecraft.orange_shulker_box": "Oranje Shulker Boks",
  "block.minecraft.orange_stained_glass": "Oranje Glas",
  "block.minecraft.orange_stained_glass_pane": "Oranje Gekleurde Glaspaneel",
  "block.minecraft.orange_terracotta": "Oranje Terracotta",
  "block.minecraft.orange_tulip": "Oranje Tulp",
  "block.minecraft.orange_wool": "Oranje Wol",
  "block.minecraft.oxeye_daisy": "Madeliefie",
  "block.minecraft.oxidized_chiseled_copper": "Geoksideerde gebeitelde koper",
  "block.minecraft.oxidized_copper": "Geoksiderde Koperblok",
  "block.minecraft.oxidized_copper_bars": "Geoksideerde Koper Tralies",
  "block.minecraft.oxidized_copper_bulb": "Geoksideerde Koper Gloeilamp",
  "block.minecraft.oxidized_copper_chain": "Geoksideerde Koper Ketting",
  "block.minecraft.oxidized_copper_chest": "Geoksideerde Koper Kus",
  "block.minecraft.oxidized_copper_door": "Geoksideerde koperdeur",
  "block.minecraft.oxidized_copper_golem_statue": "Geoksideerde Koper Golem Standbeeld",
  "block.minecraft.oxidized_copper_grate": "Geoksideerde koperrooster",
  "block.minecraft.oxidized_copper_lantern": "Geoksideerde Koper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Geoksideerde koper valdeur",
  "block.minecraft.oxidized_cut_copper": "Geoksideerde Gesnyde Koperblok",
  "block.minecraft.oxidized_cut_copper_slab": "Geoksideerde Gesnyde Koper blad",
  "block.minecraft.oxidized_cut_copper_stairs": "Geoksideerde Gesnyde Koper trappe",
  "block.minecraft.oxidized_lightning_rod": "Geoksideerde Weerligstang",
  "block.minecraft.packed_ice": "Gepakte Ys",
  "block.minecraft.packed_mud": "Gepakte Modder",
  "block.minecraft.pale_hanging_moss": "Bleek Hangende Mos",
  "block.minecraft.pale_moss_block": "Vaal Mos Blok",
  "block.minecraft.pale_moss_carpet": "Vaal Mos Mat",
  "block.minecraft.pale_oak_button": "Vaal Eikehout Knoppie",
  "block.minecraft.pale_oak_door": "Vaal Eikehout Deur",
  "block.minecraft.pale_oak_fence": "Vaal Eikehout Heining",
  "block.minecraft.pale_oak_fence_gate": "Vaal Eikehout Heining Hek",
  "block.minecraft.pale_oak_hanging_sign": "Vaal Eikehout Hangende Bordtjie",
  "block.minecraft.pale_oak_leaves": "Vaal Eikehout Blare",
  "block.minecraft.pale_oak_log": "Vaal Eikehout Stam",
  "block.minecraft.pale_oak_planks": "Vaal Eikehout Planke",
  "block.minecraft.pale_oak_pressure_plate": "Vaal Eikehout Druk Plaat",
  "block.minecraft.pale_oak_sapling": "Vaal Eikehout Stiggie",
  "block.minecraft.pale_oak_shelf": "Bleek Eikehout Rak",
  "block.minecraft.pale_oak_sign": "Bleek Eikehout bord",
  "block.minecraft.pale_oak_slab": "Vaal Eikehout Blad",
  "block.minecraft.pale_oak_stairs": "Vaal Eikehout Trappe",
  "block.minecraft.pale_oak_trapdoor": "Vaal Eikehout Valdeur",
  "block.minecraft.pale_oak_wall_hanging_sign": "Vaal Eikehout Muur Hangende Bordjie",
  "block.minecraft.pale_oak_wall_sign": "Vaal Eikehout Muur Bord",
  "block.minecraft.pale_oak_wood": "Vaal Eikehout",
  "block.minecraft.pearlescent_froglight": "Pêrelscent Paddalig",
  "block.minecraft.peony": "Pinksterroos",
  "block.minecraft.petrified_oak_slab": "Versteekste Eikehout Blad",
  "block.minecraft.piglin_head": "Piglin Kop",
  "block.minecraft.piglin_wall_head": "Piglin Muur Kop",
  "block.minecraft.pink_banner": "Pienk Banier",
  "block.minecraft.pink_bed": "Pienk Bed",
  "block.minecraft.pink_candle": "Pienk Kers",
  "block.minecraft.pink_candle_cake": "Koek met Pienk Kersie",
  "block.minecraft.pink_carpet": "Pienk Mat",
  "block.minecraft.pink_concrete": "Pienk Beton",
  "block.minecraft.pink_concrete_powder": "Pienk Beton Poeier",
  "block.minecraft.pink_glazed_terracotta": "Pienk Geglasuurde Terracotta",
  "block.minecraft.pink_petals": "Pienk Blomblare",
  "block.minecraft.pink_shulker_box": "Pienk Shulker Boks",
  "block.minecraft.pink_stained_glass": "Pienk Glas",
  "block.minecraft.pink_stained_glass_pane": "Pienk Gekleurde Glaspaneel",
  "block.minecraft.pink_terracotta": "Pienk Terracotta",
  "block.minecraft.pink_tulip": "Pienk Tulp",
  "block.minecraft.pink_wool": "Pienk Wol",
  "block.minecraft.piston": "Pompsuier",
  "block.minecraft.piston_head": "Suier kop",
  "block.minecraft.pitcher_crop": "Kruik Oes",
  "block.minecraft.pitcher_plant": "Kruik Plant",
  "block.minecraft.player_head": "Speler Kop",
  "block.minecraft.player_head.named": "%s se Kop",
  "block.minecraft.player_wall_head": "Speler Muur Kop",
  "block.minecraft.podzol": "Suurgrond",
  "block.minecraft.pointed_dripstone": "Gepunte Drupsteen blok",
  "block.minecraft.polished_andesite": "Gepoleerde Andesiet",
  "block.minecraft.polished_andesite_slab": "Gepoleerde Andesiet Blad",
  "block.minecraft.polished_andesite_stairs": "Gepoleerde Andesiet Trappe",
  "block.minecraft.polished_basalt": "Gepoleerde Basalt",
  "block.minecraft.polished_blackstone": "Gepoleerde Swartsteen",
  "block.minecraft.polished_blackstone_brick_slab": "Gepoleerde Swartsteen Baksteenblad",
  "block.minecraft.polished_blackstone_brick_stairs": "Gepoleerde Swartsteen Baksteentrappe",
  "block.minecraft.polished_blackstone_brick_wall": "Gepoleerde Swartsteen Baksteenmuur",
  "block.minecraft.polished_blackstone_bricks": "Gepoleerde Swartsteen Bakstene",
  "block.minecraft.polished_blackstone_button": "Gepoleerde Swartsteen Knoppie",
  "block.minecraft.polished_blackstone_pressure_plate": "Gepoleerde Swartsteen Drukplaat",
  "block.minecraft.polished_blackstone_slab": "Gepoleerde Swartsteenblad",
  "block.minecraft.polished_blackstone_stairs": "Gepoleerde Swartsteentrappe",
  "block.minecraft.polished_blackstone_wall": "Gepoleerde Swartsteenmuur",
  "block.minecraft.polished_deepslate": "Gepoleerde Leisteen",
  "block.minecraft.polished_deepslate_slab": "Gepoleerde Leisteenblad",
  "block.minecraft.polished_deepslate_stairs": "Gepoleerde Leisteentrappe",
  "block.minecraft.polished_deepslate_wall": "Gepoleerde Leisteenmuur",
  "block.minecraft.polished_diorite": "Gepoleerde Dioriet",
  "block.minecraft.polished_diorite_slab": "Gepoleerde Dioriet Blad",
  "block.minecraft.polished_diorite_stairs": "Gepoleerde Dioriet Trappe",
  "block.minecraft.polished_granite": "Gepoleerde Graniet",
  "block.minecraft.polished_granite_slab": "Gepoleerde Graniet Blad",
  "block.minecraft.polished_granite_stairs": "Gepoleerde Graniet Trappe",
  "block.minecraft.polished_tuff": "Gepoleerde Tuff",
  "block.minecraft.polished_tuff_slab": "Gepoleerde tufblad",
  "block.minecraft.polished_tuff_stairs": "Gepoleerde Tuff Trappe",
  "block.minecraft.polished_tuff_wall": "Gepoleerde Tuff Muur",
  "block.minecraft.poppy": "Papawer",
  "block.minecraft.potatoes": "Aartappels",
  "block.minecraft.potted_acacia_sapling": "Gekapte Akasiaboom",
  "block.minecraft.potted_allium": "Gekapte Allium",
  "block.minecraft.potted_azalea_bush": "Pot Azalea",
  "block.minecraft.potted_azure_bluet": "Gepotte Koringblomme",
  "block.minecraft.potted_bamboo": "Gepotte Bamboes",
  "block.minecraft.potted_birch_sapling": "Gekapte Berkboom",
  "block.minecraft.potted_blue_orchid": "Gekapte Blou Orgidee",
  "block.minecraft.potted_brown_mushroom": "Gepotte Bruin Sampioen",
  "block.minecraft.potted_cactus": "Gepotte Kaktus",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Geplante Toegemaakte Oogbloeisel",
  "block.minecraft.potted_cornflower": "Potkruidblom",
  "block.minecraft.potted_crimson_fungus": "Gepotte Bloedrooi Swam",
  "block.minecraft.potted_crimson_roots": "Gepotte Bloedrooi Wortels",
  "block.minecraft.potted_dandelion": "Gekapte Paardebloem",
  "block.minecraft.potted_dark_oak_sapling": "Gekapte Donkereikehoutboom",
  "block.minecraft.potted_dead_bush": "Gepotte Dooie Bossie",
  "block.minecraft.potted_fern": "Gekapte Varing",
  "block.minecraft.potted_flowering_azalea_bush": "Pot Blommende Azalia",
  "block.minecraft.potted_golden_dandelion": "Potplante goue paardebloem",
  "block.minecraft.potted_jungle_sapling": "Gekapte Oerwoudboom",
  "block.minecraft.potted_lily_of_the_valley": "Pot Lelie van die vallei",
  "block.minecraft.potted_mangrove_propagule": "Pot Mangrove Voortplanting",
  "block.minecraft.potted_oak_sapling": "Gekapte Eikehoutboom",
  "block.minecraft.potted_open_eyeblossom": "Geplante Oop Oogbloeisel",
  "block.minecraft.potted_orange_tulip": "Gopotte Oranje Tulp",
  "block.minecraft.potted_oxeye_daisy": "Gepotte Madeliefie",
  "block.minecraft.potted_pale_oak_sapling": "Geplante Vaal Eikehout Stiggie",
  "block.minecraft.potted_pink_tulip": "Gepotte Pienk Tulp",
  "block.minecraft.potted_poppy": "Gekapte Papawer",
  "block.minecraft.potted_red_mushroom": "Gepotte Rooi Sampioen",
  "block.minecraft.potted_red_tulip": "Gopotte Rooi Tulp",
  "block.minecraft.potted_spruce_sapling": "Gekapte Sparboom",
  "block.minecraft.potted_torchflower": "Potted Fakkelblom",
  "block.minecraft.potted_warped_fungus": "Gepotte Vreemde Swam",
  "block.minecraft.potted_warped_roots": "Gepotte Vreemde Wortels",
  "block.minecraft.potted_white_tulip": "Gopotte Wit Tulp",
  "block.minecraft.potted_wither_rose": "Pot Verwelk Rose",
  "block.minecraft.powder_snow": "Poeiersneeu",
  "block.minecraft.powder_snow_cauldron": "Poeiersneeuketel",
  "block.minecraft.powered_rail": "Aandrywingsspoor",
  "block.minecraft.prismarine": "Prismaryn",
  "block.minecraft.prismarine_brick_slab": "Prismaryn Baksteen Blad",
  "block.minecraft.prismarine_brick_stairs": "Prismaryn Baksteen Trappe",
  "block.minecraft.prismarine_bricks": "Prismaryn Bakstene",
  "block.minecraft.prismarine_slab": "Prismaryn Blad",
  "block.minecraft.prismarine_stairs": "Prismaryn Trappe",
  "block.minecraft.prismarine_wall": "Prismarine Muur",
  "block.minecraft.pumpkin": "Pampoen",
  "block.minecraft.pumpkin_stem": "Pampoenstingel",
  "block.minecraft.purple_banner": "Pers Vlag",
  "block.minecraft.purple_bed": "Pers Bed",
  "block.minecraft.purple_candle": "Pers Kersie",
  "block.minecraft.purple_candle_cake": "Koek met Pers Kersie",
  "block.minecraft.purple_carpet": "Pers Mat",
  "block.minecraft.purple_concrete": "Pers Beton",
  "block.minecraft.purple_concrete_powder": "Pers Beton Poeier",
  "block.minecraft.purple_glazed_terracotta": "Pers Geglasuurde Terracotta",
  "block.minecraft.purple_shulker_box": "Pers Shulker Boks",
  "block.minecraft.purple_stained_glass": "Pers Glas",
  "block.minecraft.purple_stained_glass_pane": "Pers Glaspaneel",
  "block.minecraft.purple_terracotta": "Pers Terracotta",
  "block.minecraft.purple_wool": "Pers Wol",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpur Pilaar",
  "block.minecraft.purpur_slab": "Purpur-blad",
  "block.minecraft.purpur_stairs": "Purpur Trappe",
  "block.minecraft.quartz_block": "Kwartsblok",
  "block.minecraft.quartz_bricks": "Kwarts Bakstene",
  "block.minecraft.quartz_pillar": "Kwarts Pilaar",
  "block.minecraft.quartz_slab": "Kwartsblad",
  "block.minecraft.quartz_stairs": "Kwarts Trappe",
  "block.minecraft.rail": "Spoor",
  "block.minecraft.raw_copper_block": "Rou-koperblok",
  "block.minecraft.raw_gold_block": "Blok rou goud",
  "block.minecraft.raw_iron_block": "Blok rou yster",
  "block.minecraft.red_banner": "Rooi Banier",
  "block.minecraft.red_bed": "Rooi Bed",
  "block.minecraft.red_candle": "Rooi Kersie",
  "block.minecraft.red_candle_cake": "Koek met Rooi Kersie",
  "block.minecraft.red_carpet": "Rooi Mat",
  "block.minecraft.red_concrete": "Rooi Beton",
  "block.minecraft.red_concrete_powder": "Rooi Beton Poeier",
  "block.minecraft.red_glazed_terracotta": "Rooi Geglasuurde Terracotta",
  "block.minecraft.red_mushroom": "Rooi Sampioen",
  "block.minecraft.red_mushroom_block": "Rooi Sampioen Blok",
  "block.minecraft.red_nether_brick_slab": "Rooi Laer Baksteen Blad",
  "block.minecraft.red_nether_brick_stairs": "Rooi Laer Baksteen Trappe",
  "block.minecraft.red_nether_brick_wall": "Rooi Laer Baksteen Muur",
  "block.minecraft.red_nether_bricks": "Rooi Laer Bakstene",
  "block.minecraft.red_sand": "Rooi Sand",
  "block.minecraft.red_sandstone": "Rooi Sandsteen",
  "block.minecraft.red_sandstone_slab": "Rooi Sandsteenblad",
  "block.minecraft.red_sandstone_stairs": "Rooi Sandsteen Trappe",
  "block.minecraft.red_sandstone_wall": "Rooi Sandsteen Muur",
  "block.minecraft.red_shulker_box": "Rooi Shulker Boks",
  "block.minecraft.red_stained_glass": "Rooi Glas",
  "block.minecraft.red_stained_glass_pane": "Rooi Glaspaneel",
  "block.minecraft.red_terracotta": "Rooi Terracotta",
  "block.minecraft.red_tulip": "Rooi Tulp",
  "block.minecraft.red_wool": "Rooi Wol",
  "block.minecraft.redstone_block": "Redstone-blok",
  "block.minecraft.redstone_lamp": "Redstone Lamp",
  "block.minecraft.redstone_ore": "Redstone-Erts",
  "block.minecraft.redstone_torch": "Redstone Fakkel",
  "block.minecraft.redstone_wall_torch": "Redstone Muur Fakkel",
  "block.minecraft.redstone_wire": "Redstone Draad",
  "block.minecraft.reinforced_deepslate": "Versterkte Deepslate",
  "block.minecraft.repeater": "Redstone Versterker",
  "block.minecraft.repeating_command_block": "Herhalende Opdragblok",
  "block.minecraft.resin_block": "Blok van Hars",
  "block.minecraft.resin_brick_slab": "Hars Baksteen Blad",
  "block.minecraft.resin_brick_stairs": "Hars Baksteen Trappe",
  "block.minecraft.resin_brick_wall": "Hars Baksteen Muur",
  "block.minecraft.resin_bricks": "Hars Bakstene",
  "block.minecraft.resin_clump": "Klop Hars",
  "block.minecraft.respawn_anchor": "Hervestigingsanker",
  "block.minecraft.rooted_dirt": "Gewortelde grond",
  "block.minecraft.rose_bush": "Roosbos",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandsteen",
  "block.minecraft.sandstone_slab": "Sandsteenblad",
  "block.minecraft.sandstone_stairs": "Sandsteen Trappe",
  "block.minecraft.sandstone_wall": "Sandsteen Muur",
  "block.minecraft.scaffolding": "Steierwerk",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk katalisator",
  "block.minecraft.sculk_sensor": "Sculk Sensor",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Sculk Aar",
  "block.minecraft.sea_lantern": "See Lantern",
  "block.minecraft.sea_pickle": "See Pickle",
  "block.minecraft.seagrass": "Seegras",
  "block.minecraft.set_spawn": "Hervestigingspunt gestel",
  "block.minecraft.short_dry_grass": "Kort droë gras",
  "block.minecraft.short_grass": "Kort gras",
  "block.minecraft.shroomlight": "Sampioenlig",
  "block.minecraft.shulker_box": "Shulker boks",
  "block.minecraft.skeleton_skull": "Geraamte Skedel",
  "block.minecraft.skeleton_wall_skull": "Geraamte Muurskedel",
  "block.minecraft.slime_block": "Slymblok",
  "block.minecraft.small_amethyst_bud": "Klein Ametisknoppie",
  "block.minecraft.small_dripleaf": "Klein Drupblaar",
  "block.minecraft.smithing_table": "Smithing Tafel",
  "block.minecraft.smoker": "Rookoond",
  "block.minecraft.smooth_basalt": "Gladde Basalt",
  "block.minecraft.smooth_quartz": "Gladde Kwarts Blok",
  "block.minecraft.smooth_quartz_slab": "Gladde Kwarts Blad",
  "block.minecraft.smooth_quartz_stairs": "Gladde Kwarts Trappe",
  "block.minecraft.smooth_red_sandstone": "Gladde Rooi Sandsteen",
  "block.minecraft.smooth_red_sandstone_slab": "Rooi Sandsteen Blad",
  "block.minecraft.smooth_red_sandstone_stairs": "Rooi Sandsteen Trappe",
  "block.minecraft.smooth_sandstone": "Gladde Sandsteen",
  "block.minecraft.smooth_sandstone_slab": "Gladde Sandsteen Blad",
  "block.minecraft.smooth_sandstone_stairs": "Gladde Sandsteen Trappe",
  "block.minecraft.smooth_stone": "Gladde Klip",
  "block.minecraft.smooth_stone_slab": "Gladde Klipblad",
  "block.minecraft.sniffer_egg": "Snuffel Eier",
  "block.minecraft.snow": "Sneeu",
  "block.minecraft.snow_block": "Sneeublok",
  "block.minecraft.soul_campfire": "Siel Kampvuur",
  "block.minecraft.soul_fire": "Siel Vuur",
  "block.minecraft.soul_lantern": "Siellantern",
  "block.minecraft.soul_sand": "Sielsand",
  "block.minecraft.soul_soil": "Siel Grond",
  "block.minecraft.soul_torch": "Sielfakkel",
  "block.minecraft.soul_wall_torch": "Siel Muurfakkel",
  "block.minecraft.spawn.not_valid": "Jy het geen tuisbed of gelaaide hervestigingsanker nie, of dit was belemmer",
  "block.minecraft.spawner": "Monster genereerder",
  "block.minecraft.spawner.desc1": "Interaksie met genereer eier:",
  "block.minecraft.spawner.desc2": "Stel gepeupel tipe",
  "block.minecraft.sponge": "Spons",
  "block.minecraft.spore_blossom": "Spoorbloeisel",
  "block.minecraft.spruce_button": "Spar Knoppie",
  "block.minecraft.spruce_door": "Dennehout Deur",
  "block.minecraft.spruce_fence": "Dennehout Heining",
  "block.minecraft.spruce_fence_gate": "Dennehout Hek",
  "block.minecraft.spruce_hanging_sign": "Spar Hang Teken",
  "block.minecraft.spruce_leaves": "Dennenaalde",
  "block.minecraft.spruce_log": "Spar Stomp",
  "block.minecraft.spruce_planks": "Dennehout Planke",
  "block.minecraft.spruce_pressure_plate": "Spar Drukplaat",
  "block.minecraft.spruce_sapling": "Denneboom Stiggie",
  "block.minecraft.spruce_shelf": "Sparhout Rak",
  "block.minecraft.spruce_sign": "Spruitteken",
  "block.minecraft.spruce_slab": "Spar Blad",
  "block.minecraft.spruce_stairs": "Spar Trappe",
  "block.minecraft.spruce_trapdoor": "Spar Valdeur",
  "block.minecraft.spruce_wall_hanging_sign": "Eike muur hangende teken",
  "block.minecraft.spruce_wall_sign": "Spar Muur Teken",
  "block.minecraft.spruce_wood": "Dennehout",
  "block.minecraft.sticky_piston": "Taai Pompsuier",
  "block.minecraft.stone": "Klip",
  "block.minecraft.stone_brick_slab": "Klipsteenblad",
  "block.minecraft.stone_brick_stairs": "Klipsteen Trappe",
  "block.minecraft.stone_brick_wall": "Klip Baksteen Muur",
  "block.minecraft.stone_bricks": "Klipstene",
  "block.minecraft.stone_button": "Klip Knoppie",
  "block.minecraft.stone_pressure_plate": "Klip Drukplaat",
  "block.minecraft.stone_slab": "Klipblad",
  "block.minecraft.stone_stairs": "Steen Trappe",
  "block.minecraft.stonecutter": "Klipsnyer",
  "block.minecraft.stripped_acacia_log": "Gestroopte Akasiahout Stomp",
  "block.minecraft.stripped_acacia_wood": "Gestroopte Akasiahout",
  "block.minecraft.stripped_bamboo_block": "Block van gesptreepde bamboes",
  "block.minecraft.stripped_birch_log": "Gestroopte Berk Stomp",
  "block.minecraft.stripped_birch_wood": "Gestroopte Berkhout",
  "block.minecraft.stripped_cherry_log": "Gestroopte Kersie-Stok",
  "block.minecraft.stripped_cherry_wood": "Gestroopte Kersiehout",
  "block.minecraft.stripped_crimson_hyphae": "Gestroopte Bloedrooi Styfstrepe",
  "block.minecraft.stripped_crimson_stem": "Gestroopte Bloedrooi Steel",
  "block.minecraft.stripped_dark_oak_log": "Gestroopte Donker Eikehout Stomp",
  "block.minecraft.stripped_dark_oak_wood": "Gestroopte Donker Eikehout",
  "block.minecraft.stripped_jungle_log": "Gestroopte Oerwoudhout Stomp",
  "block.minecraft.stripped_jungle_wood": "Gestroopte Oerwoudhout",
  "block.minecraft.stripped_mangrove_log": "Gestroopde Mangrove Log",
  "block.minecraft.stripped_mangrove_wood": "Gestroopde Mangrove Hout",
  "block.minecraft.stripped_oak_log": "Gestroopte eikehouthout",
  "block.minecraft.stripped_oak_wood": "Gestroopte Eikehout",
  "block.minecraft.stripped_pale_oak_log": "Gestroopte bleek eikehouthout",
  "block.minecraft.stripped_pale_oak_wood": "Gestroopte bleek eikehout",
  "block.minecraft.stripped_spruce_log": "Gestroopte Spar Stomp",
  "block.minecraft.stripped_spruce_wood": "Gestroopte Sparhout",
  "block.minecraft.stripped_warped_hyphae": "Vreemde Gestroopte Skyfstrepe",
  "block.minecraft.stripped_warped_stem": "Gestroopte Vreemde Steel",
  "block.minecraft.structure_block": "Struktuurblok",
  "block.minecraft.structure_void": "Struktuur Leemte",
  "block.minecraft.sugar_cane": "Suikerriet",
  "block.minecraft.sunflower": "Sonneblom",
  "block.minecraft.suspicious_gravel": "Verdagte Gruis",
  "block.minecraft.suspicious_sand": "Verdagte Sand",
  "block.minecraft.sweet_berry_bush": "Soetbessiebos",
  "block.minecraft.tall_dry_grass": "Lang Droë Gras",
  "block.minecraft.tall_grass": "Hoë Gras",
  "block.minecraft.tall_seagrass": "Hoë Seegras",
  "block.minecraft.target": "Teiken",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Toets Blok",
  "block.minecraft.test_instance_block": "Toets instansie Blok",
  "block.minecraft.tinted_glass": "Getinte Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-ontploffings is gedeaktiveer",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Die fakkelblom",
  "block.minecraft.torchflower_crop": "Fakkelblom Gewas",
  "block.minecraft.trapped_chest": "Lokval Kis",
  "block.minecraft.trial_spawner": "Proefnemer Verwekker",
  "block.minecraft.tripwire": "Strikdraad",
  "block.minecraft.tripwire_hook": "Strikdraad Haak",
  "block.minecraft.tube_coral": "Buiskoraal",
  "block.minecraft.tube_coral_block": "Buiskoraal Blok",
  "block.minecraft.tube_coral_fan": "Gespreide Buiskoraal",
  "block.minecraft.tube_coral_wall_fan": "Muur-gespreide Buiskoraal",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuff baksteenplaat",
  "block.minecraft.tuff_brick_stairs": "Tuff Baksteen Trappe",
  "block.minecraft.tuff_brick_wall": "Tuff baksteen muur",
  "block.minecraft.tuff_bricks": "Tuff Bakstene",
  "block.minecraft.tuff_slab": "Tuff Plaat",
  "block.minecraft.tuff_stairs": "Tuff Trappe",
  "block.minecraft.tuff_wall": "Tuff muur",
  "block.minecraft.turtle_egg": "Skilpad Eier",
  "block.minecraft.twisting_vines": "Wingende Wingerdstokke",
  "block.minecraft.twisting_vines_plant": "Draai Wingerde Plant",
  "block.minecraft.vault": "Kluis",
  "block.minecraft.verdant_froglight": "Pragtige Paddalig",
  "block.minecraft.vine": "Klimplante",
  "block.minecraft.void_air": "Leemte Lug",
  "block.minecraft.wall_torch": "Muur Fakkel",
  "block.minecraft.warped_button": "Vreemde Knoppie",
  "block.minecraft.warped_door": "Vreemde Deur",
  "block.minecraft.warped_fence": "Vreemde Heining",
  "block.minecraft.warped_fence_gate": "Vreemde Hek",
  "block.minecraft.warped_fungus": "Vreemde Swam",
  "block.minecraft.warped_hanging_sign": "Verdraaide Hangende Teken",
  "block.minecraft.warped_hyphae": "Verwronge Skyfstrepe",
  "block.minecraft.warped_nylium": "Vreemde Laelium",
  "block.minecraft.warped_planks": "Vreemde Planke",
  "block.minecraft.warped_pressure_plate": "Vreemde Drukplaat",
  "block.minecraft.warped_roots": "Vreemde Wortels",
  "block.minecraft.warped_shelf": "Verdraaide Rak",
  "block.minecraft.warped_sign": "Vreemde Bord",
  "block.minecraft.warped_slab": "Vreemde Blad",
  "block.minecraft.warped_stairs": "Vreemde Trappe",
  "block.minecraft.warped_stem": "Vreemde Steel",
  "block.minecraft.warped_trapdoor": "Vreemde Valdeur",
  "block.minecraft.warped_wall_hanging_sign": "Verdraaide Muurhangende Teken",
  "block.minecraft.warped_wall_sign": "Vreemde Muurbord",
  "block.minecraft.warped_wart_block": "Vreemde Vrat Blok",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Waterketel",
  "block.minecraft.waxed_chiseled_copper": "Gewas gebeitelde koper",
  "block.minecraft.waxed_copper_bars": "Gewaste Koperstaaf",
  "block.minecraft.waxed_copper_block": "Gewaste Koperblok",
  "block.minecraft.waxed_copper_bulb": "Gewas koper gloeilamp",
  "block.minecraft.waxed_copper_chain": "Gewaste Koperketting",
  "block.minecraft.waxed_copper_chest": "Gewaste Koperkissie",
  "block.minecraft.waxed_copper_door": "Gewas koper deur",
  "block.minecraft.waxed_copper_golem_statue": "Gewaste Koper Golem Standbeeld",
  "block.minecraft.waxed_copper_grate": "Gewasde koperrooster",
  "block.minecraft.waxed_copper_lantern": "Gewaste Koper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Gewas koper valdeur",
  "block.minecraft.waxed_cut_copper": "Gewaste Gesnyde Koper",
  "block.minecraft.waxed_cut_copper_slab": "Gewaste Gesnyde Koper Blad",
  "block.minecraft.waxed_cut_copper_stairs": "Gewaste Gesnyde Koper Trap",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gewas blootgestelde gebeitelde koper",
  "block.minecraft.waxed_exposed_copper": "Gewaste Ontblote Koperblok",
  "block.minecraft.waxed_exposed_copper_bars": "Gewaste Blootgestelde Koperstaaf",
  "block.minecraft.waxed_exposed_copper_bulb": "Gewas blootgestelde koperbol",
  "block.minecraft.waxed_exposed_copper_chain": "Gewaste Blootgestelde Koperketting",
  "block.minecraft.waxed_exposed_copper_chest": "Gewaste Blootgestelde Koperkissie",
  "block.minecraft.waxed_exposed_copper_door": "Gewas blootgestelde koperdeur",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gewaste Blootgestelde Koper Golem Standbeeld",
  "block.minecraft.waxed_exposed_copper_grate": "Gewas blootgestelde koperrooster",
  "block.minecraft.waxed_exposed_copper_lantern": "Gewaste Blootgestelde Koper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gewas blootgestelde koper valdeur",
  "block.minecraft.waxed_exposed_cut_copper": "Gewaste blootgestelde Gesnyde Koper",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gewaste Ontbloot Gesnyde Koperblad",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gewaste Ontbloot Gesnyde Kopertrappe",
  "block.minecraft.waxed_exposed_lightning_rod": "Gewaste Blootgestelde Weerligstang",
  "block.minecraft.waxed_lightning_rod": "Gewaste Weerligstang",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gewas geoksideerde gebeitelde koper",
  "block.minecraft.waxed_oxidized_copper": "Gewaste Geoksideerde koper",
  "block.minecraft.waxed_oxidized_copper_bars": "Gewaste Geoksideerde Koperstaaf",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed geoksideerde koper gloeilamp",
  "block.minecraft.waxed_oxidized_copper_chain": "Gewaste Geoksideerde Koperketting",
  "block.minecraft.waxed_oxidized_copper_chest": "Gewaste Geoksideerde Koperkissie",
  "block.minecraft.waxed_oxidized_copper_door": "Gewasde geoksideerde koperdeur",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gewasde Geoksideerde Cooper Golem Standbeeld",
  "block.minecraft.waxed_oxidized_copper_grate": "Gewasde geoksideerde koperrooster",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gewaste Geoksideerde Koper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed geoksideerde koper valdeur",
  "block.minecraft.waxed_oxidized_cut_copper": "Gewaste Geoksideerde Gesnyde Koper",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewas Geoksideerde gesnyde koperblad",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gewas Geoksideerde gesnyde kopertrappe",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gewaste Geoksideerde Weerligstang",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gewas verweerde gebeitelde koper",
  "block.minecraft.waxed_weathered_copper": "Gewaste Verweerde Koperblok",
  "block.minecraft.waxed_weathered_copper_bars": "Gewaste Verweerde Koperketting",
  "block.minecraft.waxed_weathered_copper_bulb": "Gewas verweerde koperbol",
  "block.minecraft.waxed_weathered_copper_chain": "Gewaste Verweerde Koperkissie",
  "block.minecraft.waxed_weathered_copper_chest": "Gewaste Verweerde Koperkis",
  "block.minecraft.waxed_weathered_copper_door": "Gewas verweerde koperdeur",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gewaste Verweerde Koper Golem Standbeeld",
  "block.minecraft.waxed_weathered_copper_grate": "Gewas verweerde koperrooster",
  "block.minecraft.waxed_weathered_copper_lantern": "Gewaste Verweerde Koper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gewas verweerde koper valdeur",
  "block.minecraft.waxed_weathered_cut_copper": "Gewaste Verweerde Gesnyde Koper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gewaste Verweerde Gesnyde Koperblad",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gewaste Verweerde Gesnyde Kopertrappe",
  "block.minecraft.waxed_weathered_lightning_rod": "Gewaste Verweerde Weerligstang",
  "block.minecraft.weathered_chiseled_copper": "Verweerde Gebeitelde Koper",
  "block.minecraft.weathered_copper": "Verweerde Koperblok",
  "block.minecraft.weathered_copper_bars": "Verweerde Koperstaaf",
  "block.minecraft.weathered_copper_bulb": "Verweerde Koperbol",
  "block.minecraft.weathered_copper_chain": "Verweerde Koperketting",
  "block.minecraft.weathered_copper_chest": "Verweerde Koperkissie",
  "block.minecraft.weathered_copper_door": "Verweerde Koperdeur",
  "block.minecraft.weathered_copper_golem_statue": "Verweerde Koper Golem Standbeeld",
  "block.minecraft.weathered_copper_grate": "Gewas verweerde koperrooster",
  "block.minecraft.weathered_copper_lantern": "Verweerde Koper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Verweerde Kopervaldeur",
  "block.minecraft.weathered_cut_copper": "Verweerde Gesnyde Koper",
  "block.minecraft.weathered_cut_copper_slab": "Verweerde Gesnyde Koper Blad",
  "block.minecraft.weathered_cut_copper_stairs": "Verweerde Gesnyde Koper Trappe",
  "block.minecraft.weathered_lightning_rod": "Verweerde Weerligstang",
  "block.minecraft.weeping_vines": "Huilende Klimplant",
  "block.minecraft.weeping_vines_plant": "Geween Klimplant",
  "block.minecraft.wet_sponge": "Nat Spons",
  "block.minecraft.wheat": "Koring Gewasse",
  "block.minecraft.white_banner": "Wit Banier",
  "block.minecraft.white_bed": "Wit Bed",
  "block.minecraft.white_candle": "Wit Kers",
  "block.minecraft.white_candle_cake": "Koek met Wit Kersie",
  "block.minecraft.white_carpet": "Wit mat",
  "block.minecraft.white_concrete": "Wit Beton",
  "block.minecraft.white_concrete_powder": "Wit Beton Poeier",
  "block.minecraft.white_glazed_terracotta": "Wit Geglasuurde Terracotta",
  "block.minecraft.white_shulker_box": "Wit Shulker Boks",
  "block.minecraft.white_stained_glass": "Wit Glas",
  "block.minecraft.white_stained_glass_pane": "Wit Gekleurde Glaspaneel",
  "block.minecraft.white_terracotta": "Wit Terracotta",
  "block.minecraft.white_tulip": "Wit Tulp",
  "block.minecraft.white_wool": "Wit wol",
  "block.minecraft.wildflowers": "Wildeblomme",
  "block.minecraft.wither_rose": "Verwelk Roos",
  "block.minecraft.wither_skeleton_skull": "Wither Geraamte Skedel",
  "block.minecraft.wither_skeleton_wall_skull": "Verwelkde Geraamte Muur Skedel",
  "block.minecraft.yellow_banner": "Geel Banier",
  "block.minecraft.yellow_bed": "Geel Bed",
  "block.minecraft.yellow_candle": "Geel Kers",
  "block.minecraft.yellow_candle_cake": "Koek met Geel Kersie",
  "block.minecraft.yellow_carpet": "Geel Mat",
  "block.minecraft.yellow_concrete": "Geel Beton",
  "block.minecraft.yellow_concrete_powder": "Geel Beton Poeier",
  "block.minecraft.yellow_glazed_terracotta": "Geel Geglasuurde Terracotta",
  "block.minecraft.yellow_shulker_box": "Geel Shulker Boks",
  "block.minecraft.yellow_stained_glass": "Geel Glas",
  "block.minecraft.yellow_stained_glass_pane": "Geel Gekleurde Glaspaneel",
  "block.minecraft.yellow_terracotta": "Geel Terracotta",
  "block.minecraft.yellow_wool": "Geel Wol",
  "block.minecraft.zombie_head": "Zombie Kop",
  "block.minecraft.zombie_wall_head": "Zombie Muur Kop",
  "item.minecraft.acacia_boat": "Akasiahout Boot",
  "item.minecraft.acacia_chest_boat": "Akasia Boot met Kis",
  "item.minecraft.allay_spawn_egg": "Helpertjie Spawn Eier",
  "item.minecraft.amethyst_shard": "Ametis Skerf",
  "item.minecraft.angler_pottery_shard": "Hengelaar Erdewerk Skerf",
  "item.minecraft.angler_pottery_sherd": "Hengelaar Potskerf",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Boogskutter Erdewerk Skerf",
  "item.minecraft.archer_pottery_sherd": "Boogskutter Potskerf",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Wapenrusting Staander",
  "item.minecraft.arms_up_pottery_shard": "Arms Erdewerk Skerf Op",
  "item.minecraft.arms_up_pottery_sherd": "Arms Op Erdewerk Skerf Blue train with friends\n",
  "item.minecraft.arrow": "Pyl",
  "item.minecraft.axolotl_bucket": "Emmer Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl Kuit Eier",
  "item.minecraft.baked_potato": "Gebakte Aartappel",
  "item.minecraft.bamboo_chest_raft": "Bamboesvlot met Kis",
  "item.minecraft.bamboo_raft": "Bamboesvlot",
  "item.minecraft.bat_spawn_egg": "Vlermuis Kuit Eier",
  "item.minecraft.bee_spawn_egg": "By Kuit Eier",
  "item.minecraft.beef": "Rou Beesvleis",
  "item.minecraft.beetroot": "Beet",
  "item.minecraft.beetroot_seeds": "Beet Saadjies",
  "item.minecraft.beetroot_soup": "Beet Sop",
  "item.minecraft.birch_boat": "Berkehout Boot",
  "item.minecraft.birch_chest_boat": "Berk Boot met Kis",
  "item.minecraft.black_bundle": "Swart Sak",
  "item.minecraft.black_dye": "Swart Kleurstof",
  "item.minecraft.black_harness": "Swart Harnas",
  "item.minecraft.blade_pottery_shard": "Lem Erdewerk Skerf",
  "item.minecraft.blade_pottery_sherd": "Lem Potskerf",
  "item.minecraft.blaze_powder": "Opvlammer Poeier",
  "item.minecraft.blaze_rod": "Opvlammer Staaf",
  "item.minecraft.blaze_spawn_egg": "Opvlammer Kuit Eier",
  "item.minecraft.blue_bundle": "Blou Sak",
  "item.minecraft.blue_dye": "Blou Kleurstof",
  "item.minecraft.blue_egg": "Blou Eier",
  "item.minecraft.blue_harness": "Blou Harnas",
  "item.minecraft.bogged_spawn_egg": "Boggaye ondakate motta",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smid sjabloon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Straal Wapenrusting Trim",
  "item.minecraft.bone": "Been",
  "item.minecraft.bone_meal": "Beenmeel",
  "item.minecraft.book": "Boek",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure ingekeep banier patroon",
  "item.minecraft.bow": "Boog",
  "item.minecraft.bowl": "Hout Bak",
  "item.minecraft.bread": "Brood",
  "item.minecraft.breeze_rod": "Bries Stok",
  "item.minecraft.breeze_spawn_egg": "Bries Spawneier",
  "item.minecraft.brewer_pottery_shard": "Brouer Erdewerk Skerf",
  "item.minecraft.brewer_pottery_sherd": "Brouer Potskerf",
  "item.minecraft.brewing_stand": "Brou Stand",
  "item.minecraft.brick": "Baksteen",
  "item.minecraft.brown_bundle": "Bruin Sak",
  "item.minecraft.brown_dye": "Bruin Kleurstof",
  "item.minecraft.brown_egg": "Bruin Eier",
  "item.minecraft.brown_harness": "Bruin Harnas",
  "item.minecraft.brush": "Borsel",
  "item.minecraft.bucket": "Emmer",
  "item.minecraft.bundle": "Bondel",
  "item.minecraft.bundle.empty": "Leeg",
  "item.minecraft.bundle.empty.description": "Kan 'n mengsel stapel items hou",
  "item.minecraft.bundle.full": "Vol",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Brand Erdewerk Skerf",
  "item.minecraft.burn_pottery_sherd": "Brand Potskerf",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Kameel Spawn Egg",
  "item.minecraft.carrot": "Wortel",
  "item.minecraft.carrot_on_a_stick": "Wortel aan 'n Stok",
  "item.minecraft.cat_spawn_egg": "Kat Kuiteier",
  "item.minecraft.cauldron": "Ketel",
  "item.minecraft.cave_spider_spawn_egg": "Grotspinnekop Eier",
  "item.minecraft.chainmail_boots": "Maliekolder Stewels",
  "item.minecraft.chainmail_chestplate": "Maliekolder Harnas",
  "item.minecraft.chainmail_helmet": "Maliekolder Helm",
  "item.minecraft.chainmail_leggings": "Ketting Broek",
  "item.minecraft.charcoal": "Houtskool",
  "item.minecraft.cherry_boat": "Kersieboot",
  "item.minecraft.cherry_chest_boat": "Kersie Boot met Kis",
  "item.minecraft.chest_minecart": "Koekepan met Kis",
  "item.minecraft.chicken": "Rou Hoender",
  "item.minecraft.chicken_spawn_egg": "Hoender Kuit Eier",
  "item.minecraft.chorus_fruit": "Refrein Vrug",
  "item.minecraft.clay_ball": "Klei Bal",
  "item.minecraft.clock": "Horlosie",
  "item.minecraft.coal": "Steenkool",
  "item.minecraft.coast_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kuspantserafwerking",
  "item.minecraft.cocoa_beans": "Kakao Bone",
  "item.minecraft.cod": "Rou Kabeljou",
  "item.minecraft.cod_bucket": "Emmer Kabeljou",
  "item.minecraft.cod_spawn_egg": "Kabeljou Kuit Eier",
  "item.minecraft.command_block_minecart": "Koekepan met Opdragblok",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Braaivleis",
  "item.minecraft.cooked_chicken": "Gebraaide Hoender",
  "item.minecraft.cooked_cod": "Gaar Kabeljou",
  "item.minecraft.cooked_mutton": "Gaar Skaapvleis",
  "item.minecraft.cooked_porkchop": "Gaar Varktjop",
  "item.minecraft.cooked_rabbit": "Gaar Konyn",
  "item.minecraft.cooked_salmon": "Gebakde Salm",
  "item.minecraft.cookie": "Beskuitjie",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Koperstaaf",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Koei Kuit Eier",
  "item.minecraft.creaking_spawn_egg": "Krakende Kuit Eier",
  "item.minecraft.creeper_banner_pattern": "Banier Patroon",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper Wapenprent",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Lading Banier Patroon",
  "item.minecraft.creeper_spawn_egg": "Creeper Kuit Eier",
  "item.minecraft.crossbow": "Kruisboog",
  "item.minecraft.crossbow.projectile": "Projektiel:",
  "item.minecraft.crossbow.projectile.multiple": "Projektiel: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektiel: %s",
  "item.minecraft.cyan_bundle": "Siaan Sak",
  "item.minecraft.cyan_dye": "Blougroen Kleurstof",
  "item.minecraft.cyan_harness": "Cyaan Harnas",
  "item.minecraft.danger_pottery_shard": "Gevaar Erdewerk Skerf",
  "item.minecraft.danger_pottery_sherd": "Gevaar Potskerf",
  "item.minecraft.dark_oak_boat": "Donker Eikehout Boot",
  "item.minecraft.dark_oak_chest_boat": "Donker eikehoutboot met Kis",
  "item.minecraft.debug_stick": "Debug Stok",
  "item.minecraft.debug_stick.empty": "%s het geen eienskappe nie",
  "item.minecraft.debug_stick.select": "gekies \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" na %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamant Byl",
  "item.minecraft.diamond_boots": "Diamant Stewels",
  "item.minecraft.diamond_chestplate": "Diamant Borsplaat",
  "item.minecraft.diamond_helmet": "Diamant Helm",
  "item.minecraft.diamond_hoe": "Diamant Skoffel",
  "item.minecraft.diamond_horse_armor": "Diamant Perdharnas",
  "item.minecraft.diamond_leggings": "Diamant Kamaste",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diamant Pik",
  "item.minecraft.diamond_shovel": "Diamant Graaf",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Diamant Swaard",
  "item.minecraft.disc_fragment_5": "Skyffragment",
  "item.minecraft.disc_fragment_5.desc": "Musiekplaat - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolfyn Kuit Eier",
  "item.minecraft.donkey_spawn_egg": "Donkie Kuit Eier",
  "item.minecraft.dragon_breath": "Draak Asem",
  "item.minecraft.dried_kelp": "Gedroogde Kelp",
  "item.minecraft.drowned_spawn_egg": "Verdrinke Kuiteier",
  "item.minecraft.dune_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Duinpantserafwerking",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Eier",
  "item.minecraft.elder_guardian_spawn_egg": "Oerwag Kuiteier",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smarag",
  "item.minecraft.enchanted_book": "Toorboek",
  "item.minecraft.enchanted_golden_apple": "Enchanted golden apple",
  "item.minecraft.end_crystal": "End Kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Einddraakkuiteier",
  "item.minecraft.ender_eye": "Endersoog",
  "item.minecraft.ender_pearl": "Ender Pêrel",
  "item.minecraft.enderman_spawn_egg": "Eindermankuiteier",
  "item.minecraft.endermite_spawn_egg": "Eindemietkuiteier",
  "item.minecraft.evoker_spawn_egg": "Roepster Kuit Eier",
  "item.minecraft.experience_bottle": "Bottel van Betowering",
  "item.minecraft.explorer_pottery_shard": "Onsdekkingsreisiger Erdewerk Skerf",
  "item.minecraft.explorer_pottery_sherd": "Ontdekker Potskerf",
  "item.minecraft.eye_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Oogpantserafwerking",
  "item.minecraft.feather": "Veer",
  "item.minecraft.fermented_spider_eye": "Gegisde Spinnekop Oog",
  "item.minecraft.field_masoned_banner_pattern": "Veldgemesselde Banier Patroon",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Vuurbal Wapenprent",
  "item.minecraft.firework_rocket": "Vuurpyl",
  "item.minecraft.firework_rocket.flight": "Vlug Duur:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vuurwerk Ster",
  "item.minecraft.firework_star.black": "Swart",
  "item.minecraft.firework_star.blue": "Blou",
  "item.minecraft.firework_star.brown": "Bruin",
  "item.minecraft.firework_star.custom_color": "Pasgemaak",
  "item.minecraft.firework_star.cyan": "Siaan",
  "item.minecraft.firework_star.fade_to": "Vervaag tot",
  "item.minecraft.firework_star.flicker": "Flikker",
  "item.minecraft.firework_star.gray": "Grys",
  "item.minecraft.firework_star.green": "Groen",
  "item.minecraft.firework_star.light_blue": "Ligblou",
  "item.minecraft.firework_star.light_gray": "Liggrys",
  "item.minecraft.firework_star.lime": "Heldergroen",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Pienk",
  "item.minecraft.firework_star.purple": "Pers",
  "item.minecraft.firework_star.red": "Rooi",
  "item.minecraft.firework_star.shape": "Onbekende Vorm",
  "item.minecraft.firework_star.shape.burst": "Bars",
  "item.minecraft.firework_star.shape.creeper": "Creepervormig",
  "item.minecraft.firework_star.shape.large_ball": "Groot Bal",
  "item.minecraft.firework_star.shape.small_ball": "Klein Bal",
  "item.minecraft.firework_star.shape.star": "Stervormig",
  "item.minecraft.firework_star.trail": "Roete",
  "item.minecraft.firework_star.white": "Wit",
  "item.minecraft.firework_star.yellow": "Geel",
  "item.minecraft.fishing_rod": "Visstok",
  "item.minecraft.flint": "Vuursteen",
  "item.minecraft.flint_and_steel": "Aansteker",
  "item.minecraft.flow_armor_trim_smithing_template": "Smid sjabloon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Vloeipantserafwerking",
  "item.minecraft.flow_banner_pattern": "Banier patroon",
  "item.minecraft.flow_banner_pattern.desc": "Vloei",
  "item.minecraft.flow_banner_pattern.new": "Vloei Banier Patroon",
  "item.minecraft.flow_pottery_sherd": "Vloei Potskerf",
  "item.minecraft.flower_banner_pattern": "Banier patroon",
  "item.minecraft.flower_banner_pattern.desc": "Blom Wapenprent",
  "item.minecraft.flower_banner_pattern.new": "Blom Hef Banier Patroon",
  "item.minecraft.flower_pot": "Blompot",
  "item.minecraft.fox_spawn_egg": "Jakkals Kuiteier",
  "item.minecraft.friend_pottery_shard": "Vriend Erdewerk Skerf",
  "item.minecraft.friend_pottery_sherd": "Vriend Potskerf",
  "item.minecraft.frog_spawn_egg": "Padda Spawn Eier",
  "item.minecraft.furnace_minecart": "Koekepan Enjin",
  "item.minecraft.ghast_spawn_egg": "Woeder Kuit Eier",
  "item.minecraft.ghast_tear": "Ghast Traan",
  "item.minecraft.glass_bottle": "Glasbottel",
  "item.minecraft.glistering_melon_slice": "Glinsterende Waatlemoenskyf",
  "item.minecraft.globe_banner_pattern": "Banier patroon",
  "item.minecraft.globe_banner_pattern.desc": "Wêreld",
  "item.minecraft.globe_banner_pattern.new": "Aardbol Banier Patroon",
  "item.minecraft.glow_berries": "Gloeibessies",
  "item.minecraft.glow_ink_sac": "Gloei ink sak",
  "item.minecraft.glow_item_frame": "Gloei-raam",
  "item.minecraft.glow_squid_spawn_egg": "Glow Squid Spawn Egg",
  "item.minecraft.glowstone_dust": "Gloeisteen Poeier",
  "item.minecraft.goat_horn": "Bokhoring",
  "item.minecraft.goat_spawn_egg": "Bokkieier",
  "item.minecraft.gold_ingot": "Goud Staaf",
  "item.minecraft.gold_nugget": "Goudklont",
  "item.minecraft.golden_apple": "Goue Appel",
  "item.minecraft.golden_axe": "Goue Byl",
  "item.minecraft.golden_boots": "Goue Stewels",
  "item.minecraft.golden_carrot": "Goue Wortel",
  "item.minecraft.golden_chestplate": "Goue Borsplaat",
  "item.minecraft.golden_helmet": "Goue Helm",
  "item.minecraft.golden_hoe": "Goue Skoffel",
  "item.minecraft.golden_horse_armor": "Goue Perd Beskerming",
  "item.minecraft.golden_leggings": "Goue Kamaste",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Goue Pik",
  "item.minecraft.golden_shovel": "Goue Graaf",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Goue Swaard",
  "item.minecraft.gray_bundle": "Grys Sak",
  "item.minecraft.gray_dye": "Grys Kleurstof",
  "item.minecraft.gray_harness": "Grys Harnas",
  "item.minecraft.green_bundle": "Groen Sak",
  "item.minecraft.green_dye": "Groen Kleurstof",
  "item.minecraft.green_harness": "Groen Harnas",
  "item.minecraft.guardian_spawn_egg": "Voog Kuit Eier",
  "item.minecraft.gunpowder": "Buskruit",
  "item.minecraft.guster_banner_pattern": "Banier patroon",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banier Patroon",
  "item.minecraft.guster_pottery_sherd": "Windwaai Potskerf",
  "item.minecraft.happy_ghast_spawn_egg": "Gelukkige Ghast uitbroei eier",
  "item.minecraft.harness": "Harnas",
  "item.minecraft.heart_of_the_sea": "Hart van die Sea",
  "item.minecraft.heart_pottery_shard": "Hart Erdewerk Skerf",
  "item.minecraft.heart_pottery_sherd": "Hart Pottery Skerf",
  "item.minecraft.heartbreak_pottery_shard": "Hartseer Erdewerk Skerf",
  "item.minecraft.heartbreak_pottery_sherd": "Hartseer Pottery Skerf",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Kuiteier",
  "item.minecraft.honey_bottle": "Heuningbottel",
  "item.minecraft.honeycomb": "Heuningkoek",
  "item.minecraft.hopper_minecart": "Koekepan met Geutbak",
  "item.minecraft.horse_spawn_egg": "Perd Kuit Eier",
  "item.minecraft.host_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gasheerpantserafwerking",
  "item.minecraft.howl_pottery_shard": "Huil Erdewerk Skerf",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Skerf",
  "item.minecraft.husk_spawn_egg": "Dorsling Kuiteier",
  "item.minecraft.ink_sac": "Inksak",
  "item.minecraft.iron_axe": "Yster Byl",
  "item.minecraft.iron_boots": "Yster Stewels",
  "item.minecraft.iron_chestplate": "Yster Borsplaat",
  "item.minecraft.iron_golem_spawn_egg": "Yster Golem Kuit Eier",
  "item.minecraft.iron_helmet": "Yster Helm",
  "item.minecraft.iron_hoe": "Yster Skoffel",
  "item.minecraft.iron_horse_armor": "Yster Perdharnas",
  "item.minecraft.iron_ingot": "Yster Staaf",
  "item.minecraft.iron_leggings": "Yster Kamaste",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Yster klont",
  "item.minecraft.iron_pickaxe": "Yster Pik",
  "item.minecraft.iron_shovel": "Yster Graaf",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Yster Swaard",
  "item.minecraft.item_frame": "Voorwerp Raam",
  "item.minecraft.jungle_boat": "Mahoniehout Boot",
  "item.minecraft.jungle_chest_boat": "Oerwoutboot met Kis",
  "item.minecraft.knowledge_book": "Kennis boek",
  "item.minecraft.lapis_lazuli": "Lasuur",
  "item.minecraft.lava_bucket": "Emmer Lawa",
  "item.minecraft.lead": "Leiriem",
  "item.minecraft.leather": "Leervel",
  "item.minecraft.leather_boots": "Leer Stewels",
  "item.minecraft.leather_chestplate": "Leer Harnas",
  "item.minecraft.leather_helmet": "Leer Hoed",
  "item.minecraft.leather_horse_armor": "Leer Perd Wapenrusting",
  "item.minecraft.leather_leggings": "Leer Broek",
  "item.minecraft.light_blue_bundle": "Ligte Blou Sak",
  "item.minecraft.light_blue_dye": "Ligblou Kleurstof",
  "item.minecraft.light_blue_harness": "Ligblou Harnas",
  "item.minecraft.light_gray_bundle": "Ligte Grys Sak",
  "item.minecraft.light_gray_dye": "Liggrys Kleurstof",
  "item.minecraft.light_gray_harness": "Liggrys Harnas",
  "item.minecraft.lime_bundle": "Lemmetjie Groen Sak",
  "item.minecraft.lime_dye": "Heldergroen Kleurstof",
  "item.minecraft.lime_harness": "Limegroen Harnas",
  "item.minecraft.lingering_potion": "voortslepende doepa",
  "item.minecraft.lingering_potion.effect.awkward": "Onbeholpe Draaldoepa",
  "item.minecraft.lingering_potion.effect.empty": "Onwerkbare Draaldoepa",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Brandbestandheid Draaldoepa",
  "item.minecraft.lingering_potion.effect.harming": "Skade Dralende Doepa",
  "item.minecraft.lingering_potion.effect.healing": "Genesing Dralende Doepa",
  "item.minecraft.lingering_potion.effect.infested": "Langdurige doepa van besmetting",
  "item.minecraft.lingering_potion.effect.invisibility": "Onsigbaarheid Draaldoepa",
  "item.minecraft.lingering_potion.effect.leaping": "Spring Draaldoepa",
  "item.minecraft.lingering_potion.effect.levitation": "Levitasie Dralende Doepa",
  "item.minecraft.lingering_potion.effect.luck": "Geluk Dralende Doepa",
  "item.minecraft.lingering_potion.effect.mundane": "Alledaagse Draaldoepa",
  "item.minecraft.lingering_potion.effect.night_vision": "Nagsig Draaldoepa",
  "item.minecraft.lingering_potion.effect.oozing": "Vertraagde drankie van vloeiende",
  "item.minecraft.lingering_potion.effect.poison": "Gif Dralende Doepa",
  "item.minecraft.lingering_potion.effect.regeneration": "Regenerasie Dralende Doepa",
  "item.minecraft.lingering_potion.effect.slow_falling": "Voortsleepinde Doepa van Stadig Val",
  "item.minecraft.lingering_potion.effect.slowness": "Traagheid Draaldoepa",
  "item.minecraft.lingering_potion.effect.strength": "Krag Dralende Doepa",
  "item.minecraft.lingering_potion.effect.swiftness": "Snelheid Draaldoepa",
  "item.minecraft.lingering_potion.effect.thick": "Dik Draaldoepa",
  "item.minecraft.lingering_potion.effect.turtle_master": "Voortslepende doepa van die skilpad Meester",
  "item.minecraft.lingering_potion.effect.water": "Dralende Waterbottel",
  "item.minecraft.lingering_potion.effect.water_breathing": "Waterasem Draaldoepa",
  "item.minecraft.lingering_potion.effect.weakness": "Swakheid Dralende Doepa",
  "item.minecraft.lingering_potion.effect.weaving": "Langlopende doepa van weef",
  "item.minecraft.lingering_potion.effect.wind_charged": "Langdurige doepa van windlaa",
  "item.minecraft.llama_spawn_egg": "Llama Kuit Eier",
  "item.minecraft.lodestone_compass": "Magneetsteenkompas",
  "item.minecraft.mace": "Moker",
  "item.minecraft.magenta_bundle": "Magenta Sak",
  "item.minecraft.magenta_dye": "Magenta Kleurstof",
  "item.minecraft.magenta_harness": "Magenta Harnas",
  "item.minecraft.magma_cream": "Magma Room",
  "item.minecraft.magma_cube_spawn_egg": "Magma Kubus Kuit Eier",
  "item.minecraft.mangrove_boat": "Mangrove Boot",
  "item.minecraft.mangrove_chest_boat": "Oerwoudboot met Kis",
  "item.minecraft.map": "Leë Kaart",
  "item.minecraft.melon_seeds": "Waatlemoensaad",
  "item.minecraft.melon_slice": "Waatlemoenskyf",
  "item.minecraft.milk_bucket": "Melk Emmer",
  "item.minecraft.minecart": "Koekepan",
  "item.minecraft.miner_pottery_shard": "Mynwerker Erdewerk Skerf",
  "item.minecraft.miner_pottery_sherd": "Mynwerker Potskerf",
  "item.minecraft.mojang_banner_pattern": "Banier patroon",
  "item.minecraft.mojang_banner_pattern.desc": "Ding",
  "item.minecraft.mojang_banner_pattern.new": "Ding Banier Patroon",
  "item.minecraft.mooshroom_spawn_egg": "Moepioen Kuit Eier",
  "item.minecraft.mourner_pottery_shard": "Treurende Erdewerk Skerf",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Skerf",
  "item.minecraft.mule_spawn_egg": "Pak Donkie Kuit Eier",
  "item.minecraft.mushroom_stew": "Sampioen Bredie",
  "item.minecraft.music_disc_11": "Musiekplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musiekplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musiekplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musiekplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musiekplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musiekskyf",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musiekplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Skepper",
  "item.minecraft.music_disc_creator_music_box": "Musiekplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Skepper (Musiekdoos)",
  "item.minecraft.music_disc_far": "Musiekplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musiek Skyf",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Hoender",
  "item.minecraft.music_disc_mall": "Musiekplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musiekplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musiekplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - anderkant",
  "item.minecraft.music_disc_pigstep": "Musiekplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musiekplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Afgrond",
  "item.minecraft.music_disc_relic": "Musiekplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Oorblyfsel",
  "item.minecraft.music_disc_stal": "Musiekplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musiekplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musiekskyf",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musiekplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musiekplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rou Skaapvleis",
  "item.minecraft.name_tag": "Naamkaartjie",
  "item.minecraft.nautilus_shell": "Nautilus Skulp",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nether Baksteen",
  "item.minecraft.nether_star": "Nether Ster",
  "item.minecraft.nether_wart": "Laer wortel",
  "item.minecraft.netherite_axe": "Laeriet Byl",
  "item.minecraft.netherite_boots": "Laeriet Stewels",
  "item.minecraft.netherite_chestplate": "Netheriet-borsplaat",
  "item.minecraft.netherite_helmet": "Laeriet Helm",
  "item.minecraft.netherite_hoe": "Natheriet Skoffel",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Laeriet Ingot",
  "item.minecraft.netherite_leggings": "Laeriet Broek",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Laeriet Pik",
  "item.minecraft.netherite_scrap": "Laerietskroot",
  "item.minecraft.netherite_shovel": "Laeriet Graaf",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Laeriet Swaard",
  "item.minecraft.netherite_upgrade_smithing_template": "Smee-Sjabloon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheriet Opgradering",
  "item.minecraft.oak_boat": "Eikehout Boot",
  "item.minecraft.oak_chest_boat": "Eikehoutboot met Kis",
  "item.minecraft.ocelot_spawn_egg": "Kol Kat Kuit Eier",
  "item.minecraft.ominous_bottle": "Onheilspellende bottel",
  "item.minecraft.ominous_trial_key": "Onheilspellende proefsleutel",
  "item.minecraft.orange_bundle": "Oranje Sak",
  "item.minecraft.orange_dye": "Oranje Kleurstof",
  "item.minecraft.orange_harness": "Oranje Harnas",
  "item.minecraft.painting": "Skildery",
  "item.minecraft.pale_oak_boat": "Vaal Eikehout Boot",
  "item.minecraft.pale_oak_chest_boat": "Vaal Eikehout Boot met Kis",
  "item.minecraft.panda_spawn_egg": "Panada Kuiteier",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Papegaai Kuit Eier",
  "item.minecraft.phantom_membrane": "Spook Membraan",
  "item.minecraft.phantom_spawn_egg": "Fantoom Kuiteier",
  "item.minecraft.pig_spawn_egg": "Vark Kuit Eier",
  "item.minecraft.piglin_banner_pattern": "Banier Patroon",
  "item.minecraft.piglin_banner_pattern.desc": "Snoet",
  "item.minecraft.piglin_banner_pattern.new": "Snuit Banier Patroon",
  "item.minecraft.piglin_brute_spawn_egg": "Varklinbruut Kuiteier",
  "item.minecraft.piglin_spawn_egg": "Piglin Kuiteier",
  "item.minecraft.pillager_spawn_egg": "Plunderaar Kuiteier",
  "item.minecraft.pink_bundle": "Pienk Bundel",
  "item.minecraft.pink_dye": "Pienk Kleurstof",
  "item.minecraft.pink_harness": "Pienk Harnas",
  "item.minecraft.pitcher_plant": "Kruik Plant",
  "item.minecraft.pitcher_pod": "Kruik Peul",
  "item.minecraft.plenty_pottery_shard": "Baie Erdewerk Skerf",
  "item.minecraft.plenty_pottery_sherd": "Baie Pottery Skerf",
  "item.minecraft.poisonous_potato": "Giftige Aartappel",
  "item.minecraft.polar_bear_spawn_egg": "Ys Beer Kuit Eier",
  "item.minecraft.popped_chorus_fruit": "Gepofte Refrein Vrug",
  "item.minecraft.porkchop": "Rou Varktjop",
  "item.minecraft.potato": "Aartappel",
  "item.minecraft.potion": "Doepa",
  "item.minecraft.potion.effect.awkward": "Onbeholpe Doepa",
  "item.minecraft.potion.effect.empty": "Onwerkbare Doepa",
  "item.minecraft.potion.effect.fire_resistance": "Brandbestandheid Doepa",
  "item.minecraft.potion.effect.harming": "Skade Doepa",
  "item.minecraft.potion.effect.healing": "Genesing Doepa",
  "item.minecraft.potion.effect.infested": "Besmettingsdrankie",
  "item.minecraft.potion.effect.invisibility": "Onsigbaarheid Doepa",
  "item.minecraft.potion.effect.leaping": "Spring Doepa",
  "item.minecraft.potion.effect.levitation": "Levitasie Doepa",
  "item.minecraft.potion.effect.luck": "Geluk Doepa",
  "item.minecraft.potion.effect.mundane": "Alledaagse Doepa",
  "item.minecraft.potion.effect.night_vision": "Nagsig Doepa",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Giftige Doepa",
  "item.minecraft.potion.effect.regeneration": "Regenerasie Doepa",
  "item.minecraft.potion.effect.slow_falling": "Doepa van Stadig Val",
  "item.minecraft.potion.effect.slowness": "Traagheid Doepa",
  "item.minecraft.potion.effect.strength": "Krag Doepa",
  "item.minecraft.potion.effect.swiftness": "Snelheid Doepa",
  "item.minecraft.potion.effect.thick": "Dik Doepa",
  "item.minecraft.potion.effect.turtle_master": "Doepa van die skilpad Meester",
  "item.minecraft.potion.effect.water": "Waterbottel",
  "item.minecraft.potion.effect.water_breathing": "Waterasem Doepa",
  "item.minecraft.potion.effect.weakness": "Swakheid Doepa",
  "item.minecraft.potion.effect.weaving": "Doepa van Weef",
  "item.minecraft.potion.effect.wind_charged": "Doepa van windlaai",
  "item.minecraft.pottery_shard_archer": "Archer-Keramiekfragment",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottebakkery",
  "item.minecraft.pottery_shard_prize": "Prys Pottebakkery",
  "item.minecraft.pottery_shard_skull": "Skedel Erdewerk Skerf",
  "item.minecraft.powder_snow_bucket": "Poeiersneeu Emmer",
  "item.minecraft.prismarine_crystals": "Prismaryn Kristalle",
  "item.minecraft.prismarine_shard": "Prismaryn Skerf",
  "item.minecraft.prize_pottery_shard": "Prys Erdewerk Skerf",
  "item.minecraft.prize_pottery_sherd": "Prys Pottery Skerf",
  "item.minecraft.pufferfish": "Blaasoppie",
  "item.minecraft.pufferfish_bucket": "Emmer Blaasoppies",
  "item.minecraft.pufferfish_spawn_egg": "Opblaasvis Kuit Eier",
  "item.minecraft.pumpkin_pie": "Pampoen Pastei",
  "item.minecraft.pumpkin_seeds": "Pampoensaad",
  "item.minecraft.purple_bundle": "Pers Bundel",
  "item.minecraft.purple_dye": "Pers Kleurstof",
  "item.minecraft.purple_harness": "Pers Harnas",
  "item.minecraft.quartz": "Nether Kwarts",
  "item.minecraft.rabbit": "Rou Konyn",
  "item.minecraft.rabbit_foot": "Konyn Poot",
  "item.minecraft.rabbit_hide": "Konyn Pels",
  "item.minecraft.rabbit_spawn_egg": "Haas Kuit Eier",
  "item.minecraft.rabbit_stew": "Konyn Bredie",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Verhooger Wapenrusting Patroon",
  "item.minecraft.ravager_spawn_egg": "Ravanger Kuiteier",
  "item.minecraft.raw_copper": "Rou koper",
  "item.minecraft.raw_gold": "Rou goud",
  "item.minecraft.raw_iron": "Rou yster",
  "item.minecraft.recovery_compass": "Herstel kompas",
  "item.minecraft.red_bundle": "Rooi Sak",
  "item.minecraft.red_dye": "Rooi Kleurstof",
  "item.minecraft.red_harness": "Rooi Harnas",
  "item.minecraft.redstone": "Redstone Poeier",
  "item.minecraft.resin_brick": "Hars Baksteen",
  "item.minecraft.resin_clump": "Klomp Hars",
  "item.minecraft.rib_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Wapenrusting Patroon",
  "item.minecraft.rotten_flesh": "Vrot Vleis",
  "item.minecraft.saddle": "Saal",
  "item.minecraft.salmon": "Rou Salm",
  "item.minecraft.salmon_bucket": "Emmer Salm",
  "item.minecraft.salmon_spawn_egg": "Salm Kuit Eier",
  "item.minecraft.scrape_pottery_sherd": "Skraap Pottery Skerf",
  "item.minecraft.scute": "Skout",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wag Wapenrusting Patroon",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Vervormer Wapenrusting Patroon",
  "item.minecraft.sheaf_pottery_shard": "Gerf Erdewerk Skerf",
  "item.minecraft.sheaf_pottery_sherd": "Gerf Pottery Skerf",
  "item.minecraft.shears": "Skêr",
  "item.minecraft.sheep_spawn_egg": "Skaap Kuit Eier",
  "item.minecraft.shelter_pottery_shard": "Skuiling Erdewerk Skerf",
  "item.minecraft.shelter_pottery_sherd": "Skuiling Potskerf",
  "item.minecraft.shield": "Skild",
  "item.minecraft.shield.black": "Swart Skild",
  "item.minecraft.shield.blue": "Blou Skild",
  "item.minecraft.shield.brown": "Bruin Skild",
  "item.minecraft.shield.cyan": "Siaan Skild",
  "item.minecraft.shield.gray": "Grys Skild",
  "item.minecraft.shield.green": "Groen Skild",
  "item.minecraft.shield.light_blue": "Ligte Blou Skild",
  "item.minecraft.shield.light_gray": "Ligte Grys Skild",
  "item.minecraft.shield.lime": "Heldergroen Skild",
  "item.minecraft.shield.magenta": "Magenta Skild",
  "item.minecraft.shield.orange": "Oranje Skild",
  "item.minecraft.shield.pink": "Pienk Skild",
  "item.minecraft.shield.purple": "Pers Skild",
  "item.minecraft.shield.red": "Rooi Skild",
  "item.minecraft.shield.white": "Wit Skild",
  "item.minecraft.shield.yellow": "Geel Skild",
  "item.minecraft.shulker_shell": "Skulploerskulp",
  "item.minecraft.shulker_spawn_egg": "Skulploerkuiteier",
  "item.minecraft.sign": "Teken",
  "item.minecraft.silence_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stilte Wapenrusting Patroon",
  "item.minecraft.silverfish_spawn_egg": "Vismot Kuit Eier",
  "item.minecraft.skeleton_horse_spawn_egg": "Geraamte Perd Kuit Eier",
  "item.minecraft.skeleton_spawn_egg": "Benemonster Kuit Eier",
  "item.minecraft.skull_banner_pattern": "Banier patroon",
  "item.minecraft.skull_banner_pattern.desc": "Skedel Wapenprent",
  "item.minecraft.skull_banner_pattern.new": "Skedel Hef Banier Patroon",
  "item.minecraft.skull_pottery_shard": "Skedel Erdewerk Skerf",
  "item.minecraft.skull_pottery_sherd": "Skedel Pottery Skerf",
  "item.minecraft.slime_ball": "Slymbal",
  "item.minecraft.slime_spawn_egg": "Slyk Kuit Eier",
  "item.minecraft.smithing_template": "Smid sjabloon",
  "item.minecraft.smithing_template.applies_to": "Is van toepassing op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Voeg ingot of krystal by",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Wapenrusting",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Voeg 'n stuk van vapenrusting by",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Kristalle",
  "item.minecraft.smithing_template.ingredients": "Bestanddele:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Voeg Lariet Ingot by",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamant toerusting",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Voeg diamant wapenrusting, wapen, of gereedskap by",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Laeriet Ingot",
  "item.minecraft.smithing_template.upgrade": "Gradeer op: ",
  "item.minecraft.sniffer_spawn_egg": "Snuffel Spawn Eier",
  "item.minecraft.snort_pottery_shard": "Snork Erdewerk Skerf",
  "item.minecraft.snort_pottery_sherd": "Snork Pottery Skerf",
  "item.minecraft.snout_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snoet Wapenrusting Patroon",
  "item.minecraft.snow_golem_spawn_egg": "Yster Golem Kuit Eier",
  "item.minecraft.snowball": "Sneeubal",
  "item.minecraft.spectral_arrow": "Spektrale Pyl",
  "item.minecraft.spider_eye": "Spinnekop Oog",
  "item.minecraft.spider_spawn_egg": "Spinnekop Kuit Eier",
  "item.minecraft.spire_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spits Wapenrusting Patroon",
  "item.minecraft.splash_potion": "spat doepa",
  "item.minecraft.splash_potion.effect.awkward": "Onbeholpe Spatdoepa",
  "item.minecraft.splash_potion.effect.empty": "Onmaakbare Spatdoepa",
  "item.minecraft.splash_potion.effect.fire_resistance": "Brandbestandheid Spatdoepa",
  "item.minecraft.splash_potion.effect.harming": "Skade Spatdoepa",
  "item.minecraft.splash_potion.effect.healing": "Genesing Spatdoepa",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion van Infestasie",
  "item.minecraft.splash_potion.effect.invisibility": "Onsigbaarheid Spatdoepa",
  "item.minecraft.splash_potion.effect.leaping": "Spring Spatdoepa",
  "item.minecraft.splash_potion.effect.levitation": "Levitasie Spatdoepa",
  "item.minecraft.splash_potion.effect.luck": "Geluk Spatdoepa",
  "item.minecraft.splash_potion.effect.mundane": "Alledaagse Spatdoepa",
  "item.minecraft.splash_potion.effect.night_vision": "Nagsig Spatdoepa",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Giftige Spatdoepa",
  "item.minecraft.splash_potion.effect.regeneration": "Regenerasie Spatdoepa",
  "item.minecraft.splash_potion.effect.slow_falling": "Spat Doepa van Stadig Val",
  "item.minecraft.splash_potion.effect.slowness": "Traagheid Spatdoepa",
  "item.minecraft.splash_potion.effect.strength": "Krag Spatdoepa",
  "item.minecraft.splash_potion.effect.swiftness": "Snelheid Spatdoepa",
  "item.minecraft.splash_potion.effect.thick": "Dik Spatdoepa",
  "item.minecraft.splash_potion.effect.turtle_master": "Spat Doepa van die Skilpad Meester",
  "item.minecraft.splash_potion.effect.water": "Water Spatbottel",
  "item.minecraft.splash_potion.effect.water_breathing": "Waterasem Spatdoepa",
  "item.minecraft.splash_potion.effect.weakness": "Swakheid Spatdoepa",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion van Weef",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Dennehout Boot",
  "item.minecraft.spruce_chest_boat": "Spar Boot met Kis",
  "item.minecraft.spyglass": "Vêrkyker",
  "item.minecraft.squid_spawn_egg": "Inkvis Kuit Eier",
  "item.minecraft.stick": "Stok",
  "item.minecraft.stone_axe": "Klip Byl",
  "item.minecraft.stone_hoe": "Klip Skoffel",
  "item.minecraft.stone_pickaxe": "Klip Pik",
  "item.minecraft.stone_shovel": "Klip Graaf",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Klip Swaard",
  "item.minecraft.stray_spawn_egg": "Nagelaate Kuit Eier",
  "item.minecraft.strider_spawn_egg": "Skreder Kuiteier",
  "item.minecraft.string": "Tou",
  "item.minecraft.sugar": "Suiker",
  "item.minecraft.suspicious_stew": "Verdagte Bredie",
  "item.minecraft.sweet_berries": "Soetbessies",
  "item.minecraft.tadpole_bucket": "Emmer met Padda Visse",
  "item.minecraft.tadpole_spawn_egg": "Padda Vis Spawn Eier",
  "item.minecraft.tide_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gety Wapenrusting Patroon",
  "item.minecraft.tipped_arrow": "Gedoopte Pyl",
  "item.minecraft.tipped_arrow.effect.awkward": "Kantelpyltjie",
  "item.minecraft.tipped_arrow.effect.empty": "Onmaakbare Gedoopte Pyl",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pyl van Brandbestandheid",
  "item.minecraft.tipped_arrow.effect.harming": "Pyl van Skade",
  "item.minecraft.tipped_arrow.effect.healing": "Pyl van Genesing",
  "item.minecraft.tipped_arrow.effect.infested": "Pyl van besmetting",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pyl van Onsigbaarheid",
  "item.minecraft.tipped_arrow.effect.leaping": "Pyl van Sprong",
  "item.minecraft.tipped_arrow.effect.levitation": "Pyl van Levitasie",
  "item.minecraft.tipped_arrow.effect.luck": "Pyl van Geluk",
  "item.minecraft.tipped_arrow.effect.mundane": "Kantelpyltjie",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pyl van Nagsig",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Pyl van Gif",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pyl van Regenerasie",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pyl van Stadig Val",
  "item.minecraft.tipped_arrow.effect.slowness": "Pyl van Traagheid",
  "item.minecraft.tipped_arrow.effect.strength": "Pyl van Krag",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pyl van Snelheid",
  "item.minecraft.tipped_arrow.effect.thick": "Kantelpyltjie",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pyl van Die Skilpad Meester",
  "item.minecraft.tipped_arrow.effect.water": "Pyl van Spat",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pyl van Onderwater Asemhaling",
  "item.minecraft.tipped_arrow.effect.weakness": "Pyl van Swakheid",
  "item.minecraft.tipped_arrow.effect.weaving": "Pyl van weef",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pyl van wind laai",
  "item.minecraft.tnt_minecart": "Koekepan met TNT",
  "item.minecraft.torchflower_seeds": "Fakkelblomsaad",
  "item.minecraft.totem_of_undying": "Totem van Onsterflikheid",
  "item.minecraft.trader_llama_spawn_egg": "Handelaar Lama Kuiteier",
  "item.minecraft.trial_key": "Proef Sleutel",
  "item.minecraft.trident": "Drietand",
  "item.minecraft.tropical_fish": "Tropiese Vis",
  "item.minecraft.tropical_fish_bucket": "Emmer Tropiese Visse",
  "item.minecraft.tropical_fish_spawn_egg": "Tropiese Vis Kuit Eier",
  "item.minecraft.turtle_helmet": "Skilpad Dop",
  "item.minecraft.turtle_scute": "Skilpad Sny",
  "item.minecraft.turtle_spawn_egg": "Skilpad Kuit Eier",
  "item.minecraft.vex_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Wapenrusting Patroon",
  "item.minecraft.vex_spawn_egg": "Ergernis Kuit Eier",
  "item.minecraft.villager_spawn_egg": "Inwoner Kuit Eier",
  "item.minecraft.vindicator_spawn_egg": "Handhawer Kuiteier",
  "item.minecraft.wandering_trader_spawn_egg": "Dwaalhandelaar Kuiteier",
  "item.minecraft.ward_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Waard Wapenrusting Patroon",
  "item.minecraft.warden_spawn_egg": "Bewaarder Kuiteier",
  "item.minecraft.warped_fungus_on_a_stick": "Vreemdefungus op 'n Stok",
  "item.minecraft.water_bucket": "Emmer Water",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Padvinder Wapenrusting Patroon",
  "item.minecraft.wheat": "Koring",
  "item.minecraft.wheat_seeds": "Koring Saad",
  "item.minecraft.white_bundle": "Wit Sak",
  "item.minecraft.white_dye": "Wit Kleurstof",
  "item.minecraft.white_harness": "Wit Harnas",
  "item.minecraft.wild_armor_trim_smithing_template": "Smee-Sjabloon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wilde Wapenrusting Patroon",
  "item.minecraft.wind_charge": "Windlading",
  "item.minecraft.witch_spawn_egg": "Heks Kuit Eier",
  "item.minecraft.wither_skeleton_spawn_egg": "Donker Geraamte Kuit Eier",
  "item.minecraft.wither_spawn_egg": "Verdor kuit eier",
  "item.minecraft.wolf_armor": "Wolf Wapenrusting",
  "item.minecraft.wolf_spawn_egg": "Wolf Kuit Eier",
  "item.minecraft.wooden_axe": "Hout Byl",
  "item.minecraft.wooden_hoe": "Hout Skoffel",
  "item.minecraft.wooden_pickaxe": "Hout Pik",
  "item.minecraft.wooden_shovel": "Hout Graaf",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Hout Swaard",
  "item.minecraft.writable_book": "Boek en Pen",
  "item.minecraft.written_book": "Geskrewe Boek",
  "item.minecraft.yellow_bundle": "Geel Sak",
  "item.minecraft.yellow_dye": "Geel Kleurstof",
  "item.minecraft.yellow_harness": "Geel Harnas",
  "item.minecraft.zoglin_spawn_egg": "Zoglin Kuiteier",
  "item.minecraft.zombie_horse_spawn_egg": "Zombie Perd Kuit Eier",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombie Kuit Eier",
  "item.minecraft.zombie_villager_spawn_egg": "Zombie Inwoner Kuit Eier",
  "item.minecraft.zombified_piglin_spawn_egg": "Gezombifeerde Piglin Kuiteier"
}
export const af_za = items; 
